angular.module('ua5Templates').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('components/calendar-events/calendar-events.html',
    "<div class=\"clndr__event-list\">\n" +
    "    <div\n" +
    "        class=\"clndr__event-list__event event\"\n" +
    "        ng-repeat=\"event in events | orderBy:'calcTime'\">\n" +
    "        <a\n" +
    "            class=\"event__inner\"\n" +
    "            ng-if=\"event.eventData.eventtype !== 'Campus Tour'\"\n" +
    "            ui-sref=\"single({slug: event.slug, referrer: 'calendar', date: '{{dateString}}'})\">\n" +
    "                <div\n" +
    "                    class=\"clndr__event-list__event__image event__img\">\n" +
    "                    <img ng-src=\"{{ event.image }}\">\n" +
    "                </div>\n" +
    "                <div class=\"clndr__event-list__event__info event__info\">\n" +
    "                    <div class=\"clndr__event-list__event__info__title event__title h3\">{{ event.title }}</div>\n" +
    "                    <div class=\"clndr__event-list__event__info__subtitle event__subtitle h4\">{{ event.address }}</div>\n" +
    "                    <div class=\"clndr__event-list__event__info__subtitle event__subtitle h4\">{{ event.eventData.eventtype }}</div>\n" +
    "                    <div class=\"clndr__event-list__event__info__excerpt event__description\" ng-bind-html=\"event.summary || event.body | toTrusted\"></div>\n" +
    "                </div>\n" +
    "        </a>\n" +
    "        <a\n" +
    "            class=\"event__inner\"\n" +
    "            ng-if=\"event.eventData.eventtype === 'Campus Tour'\"\n" +
    "            ui-sref=\"home.resources({slug: 'prospective-students', section: 'visit'})\">\n" +
    "                <div class=\"clndr__event-list__event__image event__img\">\n" +
    "                    <img ng-src=\"{{ event.image }}\">\n" +
    "                </div>\n" +
    "                <div class=\"clndr__event-list__event__info event__info\">\n" +
    "                    <div class=\"clndr__event-list__event__info__title event__title h3\">{{ event.title }}</div>\n" +
    "                    <div class=\"clndr__event-list__event__info__subtitle event__subtitle h4\">{{ event.address }}</div>\n" +
    "                    <div class=\"clndr__event-list__event__info__subtitle event__subtitle h4\">{{ event.eventData.eventtype }}</div>\n" +
    "                    <div class=\"clndr__event-list__event__info__subtitle event__subtitle h4\">{{ event.eventData.tags }}</div>\n" +
    "                    <div class=\"clndr__event-list__event__info__excerpt event__description\" ng-bind-html=\"event.summary || event.body | toTrusted\"></div>\n" +
    "                </div>\n" +
    "        </a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n"
  );


  $templateCache.put('components/dropdown/dropdown.html',
    "  <div class=\"dropdown-select\">\n" +
    "    <div class=\"dropdown-select__value\" ng-click=\"menuOpen = !menuOpen\">\n" +
    "        <span>{{selectedDisplay}}</span>\n" +
    "    </div>\n" +
    "    <ul\n" +
    "        class=\"dropdown-select__menu\"\n" +
    "        ng-class=\"{'dropdown-select__menu--open': menuOpen}\">\n" +
    "        <li ng-click=\"updateModel(item.value)\" ng-repeat=\"item in list\" ng-class=\"{'selected' : valueInModel(item.value)}\">\n" +
    "            <a>{{item.name}}</a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</div>\n"
  );


  $templateCache.put('components/global-header-mobile/global-header-mobile.html',
    "<header\n" +
    "    class=\"global-header-mobile\"\n" +
    "    ng-class=\"{'global-header-mobile--open': open}\">\n" +
    "    <div class=\"global-header-mobile__inner\">\n" +
    "        <a\n" +
    "            class=\"global-header-mobile__button global-header-mobile__button--toggle\"\n" +
    "            ng-click=\"toggleNav()\">\n" +
    "        </a>\n" +
    "        <h1 class=\"global-header-mobile__logo\" ng-click=\"goHome()\">\n" +
    "            <ng-include class=\"ucla-arts-header-logo\" src=\"'/assets/img/ucla-arts-logo-stacked.svg'\"></ng-include>\n" +
    "        </h1>\n" +
    "        <a\n" +
    "            class=\"global-header-mobile__button global-header-mobile__button--search\"\n" +
    "            ng-click=\"search()\"></a>\n" +
    "    </div>\n" +
    "    <nav class=\"global-header-mobile__nav\">\n" +
    "        <ul class=\"global-header-mobile__list\">\n" +
    "            <li class=\"global-header-mobile__list__item\">\n" +
    "                <a\n" +
    "                    ui-sref=\"home\"\n" +
    "                    class=\"global-header-mobile__list__item__link link1\">\n" +
    "                    Home\n" +
    "                </a>\n" +
    "                <ul class=\"global-header-mobile__list\">\n" +
    "                    <li class=\"global-header-mobile__list__item\">\n" +
    "                        <a\n" +
    "                            class=\"global-header-mobile__list__item__link link1\"\n" +
    "                            ui-sref=\"calendar\">\n" +
    "                            Calendar\n" +
    "                        </a>\n" +
    "                    </li>\n" +
    "                    <li class=\"global-header-mobile__list__item\">\n" +
    "                        <a\n" +
    "                            class=\"global-header-mobile__list__item__link link1\"\n" +
    "                            ui-sref=\"home\">\n" +
    "                            Updates\n" +
    "                        </a>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </li>\n" +
    "            <li class=\"global-header-mobile__list__item\">\n" +
    "                <a\n" +
    "                    ui-sref=\"home.community\"\n" +
    "                    class=\"global-header-mobile__list__item__link link1\">\n" +
    "                    Community\n" +
    "                </a>\n" +
    "                <ul class=\"global-header-mobile__list\">\n" +
    "                    <li class=\"global-header-mobile__list__item\">\n" +
    "                        <a\n" +
    "                            class=\"global-header-mobile__list__item__link link1\"\n" +
    "                            ui-sref=\"home.community\">\n" +
    "                            SEE WHAT'S HAPPENING<br />\n" +
    "                            NOW @ UCLA ARTS\n" +
    "                        </a>\n" +
    "                    </li>\n" +
    "                    <li class=\"global-header-mobile__list__item\">\n" +
    "                        <a\n" +
    "                            class=\"global-header-mobile__list__item__link link1\"\n" +
    "                            href=\"https://eepurl.com/g1ZRd1\"\n" +
    "                            target=\"_blank\">\n" +
    "                            Join our mailing list\n" +
    "                        </a>\n" +
    "                    </li>\n" +
    "                    <li class=\"global-header-mobile__list__item\">\n" +
    "                        <a\n" +
    "                            class=\"global-header-mobile__list__item__link link1\"\n" +
    "                            href=\"http://eepurl.com/bboke9\"\n" +
    "                            target=\"_blank\">\n" +
    "                            Subscribe to our quarterly newsletter\n" +
    "                        </a>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </li>\n" +
    "            <li class=\"global-header-mobile__list__item\">\n" +
    "                <a\n" +
    "                    ui-sref=\"home.resources({slug:'about'})\"\n" +
    "                    class=\"global-header-mobile__list__item__link link1\">\n" +
    "                    Resources\n" +
    "                </a>\n" +
    "                <div resources-nav position=\"mobile\"></div>\n" +
    "\n" +
    "            </li>\n" +
    "            <li class=\"global-header-mobile__list__item\">\n" +
    "                <a\n" +
    "                    class=\"global-header-mobile__list__item__link link1\"\n" +
    "                    ui-sref=\"home.resources({slug: 'prospective-students'})\">\n" +
    "                    Apply\n" +
    "                </a>\n" +
    "            </li>\n" +
    "            <li class=\"global-header-mobile__list__item\">\n" +
    "                <a\n" +
    "                    class=\"global-header-mobile__list__item__link link1\"\n" +
    "                    ui-sref=\"home.resources({slug: 'giving'})\">\n" +
    "                    Give\n" +
    "                </a>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </nav>\n" +
    "</header>\n"
  );


  $templateCache.put('components/global-header/global-header.html',
    "<header\n" +
    "    class=\"global-header\"\n" +
    "    ng-class=\"{'global-header--menu': menuOpen, 'global-header--search': searchOpen}\">\n" +
    "    <!-- menu and search -->\n" +
    "    <div class=\"global-header__a\">\n" +
    "        <a\n" +
    "            class=\"global-header__link link1\"\n" +
    "            ng-click=\"showMenu()\"\n" +
    "            ng-bind=\"menuLink\">\n" +
    "        </a>\n" +
    "        <a\n" +
    "            class=\"global-header__link link1\"\n" +
    "            ng-click=\"openSearch()\">{{ searchOpen ? 'Close' : 'Search'}}</a>\n" +
    "    </div>\n" +
    "    <!-- site name -->\n" +
    "    <div class=\"global-header__b\">\n" +
    "        <h1\n" +
    "            class=\"global-header__logo\" ng-click=\"goHome()\">\n" +
    "            <ng-include class=\"ucla-arts-header-logo\" src=\"'/assets/img/ucla-arts-logo.svg'\"></ng-include>\n" +
    "        </h1>\n" +
    "    </div>\n" +
    "    <!-- apply and give -->\n" +
    "    <div class=\"global-header__c\">\n" +
    "        <a\n" +
    "            class=\"global-header__link link1\"\n" +
    "            ui-sref=\"home.resources({slug: 'prospective-students'})\">\n" +
    "            Apply\n" +
    "        </a>\n" +
    "        <a\n" +
    "            class=\"global-header__link link1\"\n" +
    "            ui-sref=\"home.resources({slug: 'giving'})\">Give</a>\n" +
    "    </div>\n" +
    "    <!-- menu -->\n" +
    "    <div menu></div>\n" +
    "</header>\n"
  );


  $templateCache.put('components/menu/menu.html',
    "<div class=\"menu\">\n" +
    "    <img\n" +
    "        src=\"assets/img/ucla-arts-logo.png\"\n" +
    "        class=\"menu__stamp\"\n" +
    "        alt=\"UCLA Arts\">\n" +
    "    <div class=\"menu__inner\">\n" +
    "        <div class=\"menu__col\">\n" +
    "            <a\n" +
    "                class=\"menu__title link1 link1--emphasis\"\n" +
    "                ui-sref=\"home.community\">\n" +
    "                Community\n" +
    "            </a>\n" +
    "            <ul class=\"menu__list\">\n" +
    "                <li class=\"menu__list__item\">\n" +
    "                    <a\n" +
    "                        class=\"menu__list__item__link link1\"\n" +
    "                        ui-sref=\"home.community\">\n" +
    "                        SEE WHAT’S HAPPENING<br />\n" +
    "                        NOW @ UCLA ARTS\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li class=\"menu__list__item\">\n" +
    "                    <a\n" +
    "                        class=\"menu__list__item__link link1\"\n" +
    "                        href=\"https://eepurl.com/g1ZRd1\"\n" +
    "                        target=\"_blank\">\n" +
    "                        Join our mailing list\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li class=\"menu__list__item\">\n" +
    "                    <a\n" +
    "                        class=\"menu__list__item__link link1\"\n" +
    "                        href=\"http://eepurl.com/bboke9\"\n" +
    "                        target=\"_blank\">\n" +
    "                        Subscribe to our quarterly newsletter\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li>\n" +
    "                    <div class=\"menu__social\">\n" +
    "                        <a\n" +
    "                            class=\"menu__social__item\"\n" +
    "                            href=\"https://www.facebook.com/ucla.arts\"\n" +
    "                            target=\"_blank\">\n" +
    "                            <svg class=\"menu__social__item__icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" viewBox=\"0 0 24 24\"><path d=\"M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z\"></svg>\n" +
    "                        </a>\n" +
    "                        <a\n" +
    "                            class=\"menu__social__item\"\n" +
    "                            href=\"https://twitter.com/uclaarts\"\n" +
    "                            target=\"_blank\">\n" +
    "                            <svg class=\"menu__social__item__icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" viewBox=\"0 0 24 24\"><path d=\"M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z\"></svg>\n" +
    "                        </a>\n" +
    "                        <a\n" +
    "                            class=\"menu__social__item\"\n" +
    "                            href=\"https://instagram.com/uclaarts/\"\n" +
    "                            target=\"_blank\">\n" +
    "                            <svg class=\"menu__social__item__icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" viewBox=\"0 0 24 24\"><path d=\"M20,6.5A0.5,0.5 0 0,1 19.5,7H17.5A0.5,0.5 0 0,1 17,6.5V4.5A0.5,0.5 0 0,1 17.5,4H19.5A0.5,0.5 0 0,1 20,4.5M4.5,20A0.5,0.5 0 0,1 4,19.5V11H6.09C6.03,11.32 6,11.66 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12C18,11.66 17.96,11.32 17.91,11H20V19.5A0.5,0.5 0 0,1 19.5,20M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M20,2H4C2.89,2 2,2.89 2,4V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V4C22,2.89 21.1,2 20,2Z\"></svg>\n" +
    "                        </a>\n" +
    "                        <a\n" +
    "                            class=\"menu__social__item\"\n" +
    "                            href=\"https://www.youtube.com/user/UCLAArts\"\n" +
    "                            target=\"_blank\">\n" +
    "                            <svg class=\"menu__social__item__icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M10,16.5V7.5L16,12M20,4.4C19.4,4.2 15.7,4 12,4C8.3,4 4.6,4.19 4,4.38C2.44,4.9 2,8.4 2,12C2,15.59 2.44,19.1 4,19.61C4.6,19.81 8.3,20 12,20C15.7,20 19.4,19.81 20,19.61C21.56,19.1 22,15.59 22,12C22,8.4 21.56,4.91 20,4.4Z\" /></svg>\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "        <div class=\"menu__col menu__col--narrow\">\n" +
    "            <a\n" +
    "                class=\"menu__title link1 link1--emphasis\"\n" +
    "                ui-sref=\"home\">\n" +
    "                Home\n" +
    "            </a>\n" +
    "            <ul class=\"menu__list\">\n" +
    "                <li class=\"menu__list__item\">\n" +
    "                    <a\n" +
    "                        class=\"menu__list__item__link link1\"\n" +
    "                        ui-sref=\"calendar\">\n" +
    "                        Calendar\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li class=\"menu__list__item\">\n" +
    "                    <a\n" +
    "                        class=\"menu__list__item__link link1\"\n" +
    "                        ui-sref=\"home\">\n" +
    "                        Updates\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "                <li class=\"menu__list__item\">\n" +
    "                    <a\n" +
    "                        class=\"menu__list__item__link link1\"\n" +
    "                        target=\"_blank\"\n" +
    "                        href=\"//arts.ucla.edu/an-imaginative-offer/\">\n" +
    "                        An Imaginative Offer\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "        <div class=\"menu__col\">\n" +
    "            <a\n" +
    "                class=\"menu__title link1 link1--emphasis\"\n" +
    "                ui-sref=\"home.resources({slug:'about'})\">\n" +
    "                Resources\n" +
    "            </a>\n" +
    "            <div resources-nav position=\"globalnav\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"menu__footer\">\n" +
    "            <div class=\"menu__footer__ua5\">\n" +
    "                Site By <a href=\"http://useallfive.com\" target=\"_blank\">Use All Five</a>\n" +
    "            </div>\n" +
    "            <div class=\"menu__footer__copyright\">\n" +
    "                &copy; {{ year }} The Regents of the University of California\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/post/post.html',
    "<div>\n" +
    "<a\n" +
    "    class=\"post\"\n" +
    "    ng-mouseenter=\"rolloverArticle(postData)\"\n" +
    "    ng-mouseleave=\"rolloverArticle(false)\"\n" +
    "    ui-sref=\"single({slug: postData.slug})\">\n" +
    "    <div\n" +
    "        scroll-reveal\n" +
    "        scroll-reveal-distance=\"10px\"\n" +
    "        scroll-reveal-delay=\"300\">\n" +
    "    <div\n" +
    "        class=\"post__category link1 link1--emphasis\"\n" +
    "        ng-click=\"changePostFilter($event, {type: 'category', name: postData.category})\"\n" +
    "        ng-bind=\"postData.category\">\n" +
    "    </div>\n" +
    "    </div>\n" +
    "    <!--\n" +
    "    <div\n" +
    "        class=\"post__program link1\"\n" +
    "        ng-if=\"postData.programs[0]\"\n" +
    "        ng-click=\"changePostFilter($event, {type: 'program', value: postData.programs[0].id})\"\n" +
    "        ng-bind=\"postData.programs[0].name\">\n" +
    "    </div>\n" +
    "    -->\n" +
    "    <div class=\"post__category-program link1 link1--emphasis\">\n" +
    "         <span ng-bind=\"postData.programs[0].name\"></span> - <span ng-bind=\"postData.category\"></span>\n" +
    "    </div>\n" +
    "    <div\n" +
    "        scroll-reveal\n" +
    "        class=\"post__media-container\">\n" +
    "        <div class=\"post__media-container__whiteout\"></div>\n" +
    "        <img\n" +
    "            class=\"post__media-container__media\"\n" +
    "            ng-src=\"{{postData.image ? postData.image : 'components/post/assets/placeholder.gif'}}\"\n" +
    "            ng-attr-alt=\"{{ postData.title }}\">\n" +
    "    </div>\n" +
    "    <div class=\"post__info-wrap\">\n" +
    "        <div\n" +
    "            scroll-reveal\n" +
    "            scroll-reveal-delay=\"500\"\n" +
    "            scroll-reveal-distance=\"10px\">\n" +
    "        <div class=\"post__info\">\n" +
    "            <h1\n" +
    "                class=\"post__info__title\"\n" +
    "                ng-bind=\"postData.title\">\n" +
    "            </h1>\n" +
    "            <h2\n" +
    "                class=\"post__info__subtitle link1\"\n" +
    "                ng-bind=\"postData.subtitle\">\n" +
    "            </h2>\n" +
    "            <div\n" +
    "                class=\"post__info__excerpt copy\"\n" +
    "                ng-bind-html=\"postData.summary\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</a>\n" +
    "</div>\n"
  );


  $templateCache.put('components/posts-filter/posts-filter.html',
    "<div class=\"posts-filter\">\n" +
    "    <div class=\"posts-filter__a\">\n" +
    "        <span\n" +
    "            class=\"link1 link1--smaller\"\n" +
    "            ng-bind=\"currentWeek\">\n" +
    "        </span>\n" +
    "        <span class=\"posts-filter__divider link1 link1--smaller\">|</span>\n" +
    "        <a\n" +
    "            class=\"posts-filter__button link1 link1--smaller\"\n" +
    "            ng-class=\"{'link1--muted': !isHome}\"\n" +
    "            ui-sref=\"home\">\n" +
    "            Features\n" +
    "        </a>\n" +
    "        <a\n" +
    "            class=\"posts-filter__button link1 link1--smaller\"\n" +
    "            ng-class=\"{'link1--muted': isHome}\"\n" +
    "            ui-sref=\"calendar\">\n" +
    "            Calendar\n" +
    "        </a>\n" +
    "    </div>\n" +
    "    <div class=\"posts-filter__b\">\n" +
    "        <span class=\"posts-filter__label link1 link1--smaller\">\n" +
    "            Filter:\n" +
    "        </span>\n" +
    "        <div class=\"posts-filter__tags \" ng-if=\"tagFilters.length > 0\">\n" +
    "            <a ng-repeat=\"tag in tagFilters\" class=\"posts-filter__tag link1 link1--smaller\" ng-click=\"deleteTag(tag.slug)\">{{tag.name}} <span class=\"close\">+</span></a>\n" +
    "        </div>\n" +
    "        <div dropdown-select list=\"categoryFilters\" model=\"currentFilters.category\" multiselect=\"true\" class=\"posts-filter__dropdown-wrapper posts-filter__dropdown-wrapper--category\"></div>\n" +
    "        <div dropdown-select list=\"programFilters\" model=\"currentFilters.program\" multiselect=\"true\" class=\"posts-filter__dropdown-wrapper posts-filter__dropdown-wrapper--program\"></div>\n" +
    "\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/posts/posts.html',
    "<div\n" +
    "    class=\"posts\"\n" +
    "    data-infinite-scroll=\"getMorePosts()\"\n" +
    "    data-infinite-scroll-disabled=\"disableInfiniteScroll\"\n" +
    "    ng-class=\"{'posts--right': onRight, 'posts--small': isSmall==true}\">\n" +
    "    <a\n" +
    "        class=\"posts__back\"\n" +
    "        ui-sref=\"home\">\n" +
    "        <div class=\"posts__back__arrow\">\n" +
    "            &#10229;\n" +
    "        </div>\n" +
    "        <div class=\"posts__back__text\">\n" +
    "            Home\n" +
    "        </div>\n" +
    "    </a>\n" +
    "    <div\n" +
    "        class=\"posts__filter-wrap\"\n" +
    "        posts-filter\n" +
    "        current-filters=\"currentFilters\">\n" +
    "    </div>\n" +
    "    <div class=\"posts__content\">\n" +
    "        <div\n" +
    "            ng-repeat=\"post in postsData\"\n" +
    "            post\n" +
    "            post-data=\"post\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"posts__social-share\">\n" +
    "    <a class=\"share__icon posts__share__icon\" href=\"https://www.facebook.com/ucla.arts\" target=\"_blank\">\n" +
    "        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" viewBox=\"0 0 24 24\"><path d=\"M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z\"></svg>\n" +
    "    </a>\n" +
    "    <a class=\"share__icon posts__share__icon\" href=\"https://twitter.com/uclaarts\" target=\"_blank\">\n" +
    "        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" viewBox=\"0 0 24 24\"><path d=\"M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z\"></svg>\n" +
    "    </a>\n" +
    "    <a class=\"share__icon posts__share__icon\" href=\"https://eepurl.com/g1ZRd1\" target=\"_blank\">\n" +
    "        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z\" /></svg>\n" +
    "    </a>\n" +
    "</div>\n" +
    "<div\n" +
    "    class=\"posts__lightbox\"\n" +
    "    id=\"posts_lightbox\"\n" +
    "    ng-class=\"{'left': smallPosition == 'left', 'right': smallPosition == 'right'}\">\n" +
    "    <div class=\"posts__lightbox__container\">\n" +
    "\n" +
    "        <div\n" +
    "            class=\"post__lightbox__category link1 link1--emphasis\"\n" +
    "            ng-bind=\"lightBoxData.category\">\n" +
    "        </div>\n" +
    "        <img\n" +
    "            class=\"posts__lightbox__image\"\n" +
    "            ng-src=\"{{lightBoxData.image}}\"\n" +
    "            ng-if=\"lightBoxData.image\"\n" +
    "            ng-attr-alt=\"{{ lightBoxData.title }}\">\n" +
    "        <div class=\"posts__lightbox__info-wrap\">\n" +
    "            <div class=\"posts__lightbox__title\">{{ lightBoxData.title }}</div>\n" +
    "            <div\n" +
    "                class=\"post__info__subtitle link1\"\n" +
    "                ng-bind=\"lightBoxData.subtitle\">\n" +
    "            </div>\n" +
    "            <div class=\"posts__lightbox__summary copy\" ng-bind-html=\"lightBoxData.summary\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-connectform/resource-connectform.html',
    "<h3 class=\"resources__main__section__title\">Connect</h3>\n" +
    "<div class=\"resource-connectform__body\">\n" +
    "    <p>Special events, exhibitions, and performances are great ways to learn more about alumni and the arts at UCLA. For a complete listing of upcoming alumni events, <a ui-sref=\"calendar\">click here</a> . Are you ready to give back? Please consider one of our volunteer or giving opportunities.</p>\n" +
    "\n" +
    "    <p>Please use the forms below to share news and accomplishments, update your contact information, provide feedback and suggestions for alumni relations, or to find out more about organizing/hosting an event.\n" +
    "    </p>\n" +
    "</div>\n" +
    "<div class=\"resource-connectform\">\n" +
    "    <form name=\"contactForm\" ng-submit=\"submitContact()\" novalidate>\n" +
    "\n" +
    "        <h3 class=\"resources-connectform__section-name\">Update Your Contact Information</h3>\n" +
    "        <h4 class=\"resources-connectform__input-name\">Name</h4>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.nameFirst,'has-error': contactForm.nameFirst.$invalid && contactForm.nameFirst.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__nameFirst\">First<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"nameFirst\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__nameFirst\"\n" +
    "                ng-focus=\"inputFocus.nameFirst = true\"\n" +
    "                ng-blur=\"inputFocus.nameFirst = false\"\n" +
    "                ng-model=\"contacts.nameFirst\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.nameMiddle}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__nameMiddle\">Middle</label>\n" +
    "            <input\n" +
    "                name=\"nameMiddle\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__nameMiddle\"\n" +
    "                ng-focus=\"inputFocus.nameMiddle = true\"\n" +
    "                ng-blur=\"inputFocus.nameMiddle = false\"\n" +
    "                ng-model=\"contacts.nameMiddle\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.nameLast, 'has-error': contactForm.nameLast.$invalid && contactForm.nameLast.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__nameLast\">Last<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"nameLast\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__nameLast\"\n" +
    "                ng-focus=\"inputFocus.nameLast = true\"\n" +
    "                ng-blur=\"inputFocus.nameLast = false\"\n" +
    "                ng-model=\"contacts.nameLast\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.nameOther}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__nameOther\">Name used when enrolled at UCLA, if different from above</label>\n" +
    "            <input\n" +
    "                name=\"nameOther\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__nameOther\"\n" +
    "                ng-focus=\"inputFocus.nameOther = true\"\n" +
    "                ng-blur=\"inputFocus.nameOther = false\"\n" +
    "                ng-model=\"contacts.nameOther\" />\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "\n" +
    "        <h4 class=\"resources-connectform__input-name\">Primary Email Address <small>(where you would like to receive alumni news, event invitations, and other email communications)</small></h4>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.email, 'has-error': contactForm.email.$invalid && contactForm.email.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__email\">Email<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"email\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__email\"\n" +
    "                ng-focus=\"inputFocus.email = true\"\n" +
    "                ng-blur=\"inputFocus.email = false\"\n" +
    "                ng-model=\"contacts.email\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "        <h4 class=\"resources-connectform__input-name\">Home Address</h4>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.addressStreet1, 'has-error': contactForm.addressStreet1.$invalid && contactForm.addressStreet1.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__addressStreet1\">Street Address 1<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"addressStreet1\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__addressStreet1\"\n" +
    "                ng-focus=\"inputFocus.addressStreet1 = true\"\n" +
    "                ng-blur=\"inputFocus.addressStreet1 = false\"\n" +
    "                ng-model=\"contacts.addressStreet1\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.addressStreet2}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__addressStreet2\">Street Address 2</label>\n" +
    "            <input\n" +
    "                name=\"addressStreet2\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__addressStreet2\"\n" +
    "                ng-focus=\"inputFocus.addressStreet2 = true\"\n" +
    "                ng-blur=\"inputFocus.addressStreet2 = false\"\n" +
    "                ng-model=\"contacts.addressStreet2\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.addressCity, 'has-error': contactForm.addressCity.$invalid && contactForm.addressCity.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__addressCity\">City<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"addressCity\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__addressCity\"\n" +
    "                ng-focus=\"inputFocus.addressCity = true\"\n" +
    "                ng-blur=\"inputFocus.addressCity = false\"\n" +
    "                ng-model=\"contacts.addressCity\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.addressState, 'has-error': contactForm.addressState.$invalid && contactForm.addressState.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__addressState\">State<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"addressState\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__addressState\"\n" +
    "                ng-focus=\"inputFocus.addressState = true\"\n" +
    "                ng-blur=\"inputFocus.addressState = false\"\n" +
    "                ng-model=\"contacts.addressState\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.addressZip, 'has-error': contactForm.addressZip.$invalid && contactForm.addressZip.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__addressZip\">Zip/Postal Code<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"addressZip\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__addressZip\"\n" +
    "                ng-focus=\"inputFocus.addressZip = true\"\n" +
    "                ng-blur=\"inputFocus.addressZip = false\"\n" +
    "                ng-model=\"contacts.addressZip\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.addressCountry}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__addressCountry\">Country</label>\n" +
    "            <input\n" +
    "                name=\"addressCountry\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__addressCountry\"\n" +
    "                ng-focus=\"inputFocus.addressCountry = true\"\n" +
    "                ng-blur=\"inputFocus.addressCountry = false\"\n" +
    "                ng-model=\"contacts.addressCountry\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.phoneHome}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__phoneHome\">Home Telephone</label>\n" +
    "            <input\n" +
    "                name=\"phoneHome\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__phoneHome\"\n" +
    "                ng-focus=\"inputFocus.phoneHome = true\"\n" +
    "                ng-blur=\"inputFocus.phoneHome = false\"\n" +
    "                ng-model=\"contacts.phoneHome\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.phoneMobile}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__phoneMobile\">Mobile Telephone</label>\n" +
    "            <input\n" +
    "                name=\"phoneMobile\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__phoneMobile\"\n" +
    "                ng-focus=\"inputFocus.phoneMobile = true\"\n" +
    "                ng-blur=\"inputFocus.phoneMobile = false\"\n" +
    "                ng-model=\"contacts.phoneMobile\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <h4 class=\"resources-connectform__input-name\">Business Information</h4>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.businessTitle}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__businessTitle\">Position/Title</label>\n" +
    "            <input\n" +
    "                name=\"businessTitle\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__businessTitle\"\n" +
    "                ng-focus=\"inputFocus.businessTitle = true\"\n" +
    "                ng-blur=\"inputFocus.businessTitle = false\"\n" +
    "                ng-model=\"contacts.businessTitle\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.businessCompany}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__businessCompany\">Company</label>\n" +
    "            <input\n" +
    "                name=\"businessCompany\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__businessCompany\"\n" +
    "                ng-focus=\"inputFocus.businessCompany = true\"\n" +
    "                ng-blur=\"inputFocus.businessCompany = false\"\n" +
    "                ng-model=\"contacts.businessCompany\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.businessField}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__businessField\">Field/Specialty</label>\n" +
    "            <input\n" +
    "                name=\"businessField\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__businessField\"\n" +
    "                ng-focus=\"inputFocus.businessField = true\"\n" +
    "                ng-blur=\"inputFocus.businessField = false\"\n" +
    "                ng-model=\"contacts.businessField\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.businessStreet1}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__businessStreet1\">Street Address 1</label>\n" +
    "            <input\n" +
    "                name=\"businessStreet1\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__businessStreet1\"\n" +
    "                ng-focus=\"inputFocus.businessStreet1 = true\"\n" +
    "                ng-blur=\"inputFocus.businessStreet1 = false\"\n" +
    "                ng-model=\"contacts.businessStreet1\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.businessStreet2}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__businessStreet2\">Street Address 2</label>\n" +
    "            <input\n" +
    "                name=\"businessStreet2\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__businessStreet2\"\n" +
    "                ng-focus=\"inputFocus.businessStreet2 = true\"\n" +
    "                ng-blur=\"inputFocus.businessStreet2 = false\"\n" +
    "                ng-model=\"contacts.businessStreet2\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.businessCity}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__businessCity\">City</label>\n" +
    "            <input\n" +
    "                name=\"businessCity\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__businessCity\"\n" +
    "                ng-focus=\"inputFocus.businessCity = true\"\n" +
    "                ng-blur=\"inputFocus.businessCity = false\"\n" +
    "                ng-model=\"contacts.businessCity\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.businessState}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__businessState\">State</label>\n" +
    "            <input\n" +
    "                name=\"businessState\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__businessState\"\n" +
    "                ng-focus=\"inputFocus.businessState = true\"\n" +
    "                ng-blur=\"inputFocus.businessState = false\"\n" +
    "                ng-model=\"contacts.businessState\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.businessZip}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__businessZip\">Zip/Postal Code</label>\n" +
    "            <input\n" +
    "                name=\"businessZip\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__businessZip\"\n" +
    "                ng-focus=\"inputFocus.businessZip = true\"\n" +
    "                ng-blur=\"inputFocus.businessZip = false\"\n" +
    "                ng-model=\"contacts.businessZip\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.businessCountry}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__businessCountry\">Country</label>\n" +
    "            <input\n" +
    "                name=\"businessCountry\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__businessCountry\"\n" +
    "                ng-focus=\"inputFocus.businessCountry = true\"\n" +
    "                ng-blur=\"inputFocus.businessCountry = false\"\n" +
    "                ng-model=\"contacts.businessCountry\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.businessPhone}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__businessPhone\">Business Telephone</label>\n" +
    "            <input\n" +
    "                name=\"businessPhone\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__businessPhone\"\n" +
    "                ng-focus=\"inputFocus.businessPhone = true\"\n" +
    "                ng-blur=\"inputFocus.businessPhone = false\"\n" +
    "                ng-model=\"contacts.businessPhone\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.businessEmail}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__businessEmail\">Business Email</label>\n" +
    "            <input\n" +
    "                name=\"businessEmail\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__businessEmail\"\n" +
    "                ng-focus=\"inputFocus.businessEmail = true\"\n" +
    "                ng-blur=\"inputFocus.businessEmail = false\"\n" +
    "                ng-model=\"contacts.businessEmail\" />\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "\n" +
    "        <h4 class=\"resources-connectform__input-name\">If you have a personal or professional website, please enter the URL below:</h4>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.website}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__website\">URL</label>\n" +
    "            <input\n" +
    "                name=\"website\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__website\"\n" +
    "                ng-focus=\"inputFocus.website = true\"\n" +
    "                ng-blur=\"inputFocus.website = false\"\n" +
    "                ng-model=\"contacts.website\" />\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resource-cta__item\">\n" +
    "            <div class=\"resource-cta__item__table\">\n" +
    "                <button type=\"submit\" class=\"resource-cta__item__link\" ng-disabled=\"contactForm.$invalid\">Submit</button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "    </form>\n" +
    "</div>\n" +
    "<div class=\"resource-connectform resource-connectform--accomplishments\">\n" +
    "    <form name=\"accomplishmentsForm\" ng-submit=\"submitAccomplishments()\" novalidate>\n" +
    "\n" +
    "        <h3 class=\"resources-connectform__section-name\">Tell Us More</h3>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.nameFirst}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__nameFirst\">First Name</label>\n" +
    "            <input\n" +
    "                name=\"nameFirst\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__nameFirst\"\n" +
    "                ng-focus=\"inputFocus.nameFirst = true\"\n" +
    "                ng-blur=\"inputFocus.nameFirst = false\"\n" +
    "                ng-model=\"accomplishments.nameFirst\" />\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.nameLast}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__nameLast\">Last Name</label>\n" +
    "            <input\n" +
    "                name=\"nameLast\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__nameLast\"\n" +
    "                ng-focus=\"inputFocus.nameLast = true\"\n" +
    "                ng-blur=\"inputFocus.nameLast = false\"\n" +
    "                ng-model=\"accomplishments.nameLast\" />\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.accomplishments}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__accomplishments\">Share your most recent accomplishment(s)</label>\n" +
    "            <textarea\n" +
    "                name=\"accomplishments\"\n" +
    "                rows=3\n" +
    "                class=\"resources-connectform__textarea\"\n" +
    "                id=\"resources-connectform__accomplishments\"\n" +
    "                ng-focus=\"inputFocus.accomplishments = true\"\n" +
    "                ng-blur=\"inputFocus.accomplishments = false\"\n" +
    "                ng-model=\"accomplishments.accomplishments\" ></textarea>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <h4 class=\"resources-connectform__input-name\">Tell us about your experience at UCLA.</h4>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.experienceHighlights}\">\n" +
    "\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__experienceHighlights\">Share some highlights of your experiences studying the arts/architecture at UCLA.</label>\n" +
    "\n" +
    "            <input\n" +
    "                name=\"experienceHighlights\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__experienceHighlights\"\n" +
    "                ng-focus=\"inputFocus.experienceHighlights = true\"\n" +
    "                ng-blur=\"inputFocus.experienceHighlights = false\"\n" +
    "                ng-model=\"accomplishments.experienceHighlights\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.experienceMentors}\">\n" +
    "\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__experienceMentors\">Tell us about your key advisors, instructors and/or mentors at UCLA, and describe those relationships.</label>\n" +
    "            <input\n" +
    "                name=\"experienceMentors\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__experienceMentors\"\n" +
    "                ng-focus=\"inputFocus.experienceMentors = true\"\n" +
    "                ng-blur=\"inputFocus.experienceMentors = false\"\n" +
    "                ng-model=\"accomplishments.experienceMentors\"/>\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.experienceStudy}\">\n" +
    "\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__experienceStudy\">How did your study of the arts complement or enhance your area of concentration? </label>\n" +
    "            <input\n" +
    "                name=\"experienceStudy\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__experienceStudy\"\n" +
    "                ng-focus=\"inputFocus.experienceStudy = true\"\n" +
    "                ng-blur=\"inputFocus.experienceStudy = false\"\n" +
    "                ng-model=\"accomplishments.experienceStudy\"\n" +
    "                 />\n" +
    "        </div>\n" +
    "\n" +
    "        <h4 class=\"resources-connectform__input-name\">Tell us about your experience after studying at UCLA.</h4>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.experienceAfter}\">\n" +
    "\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__experienceAfter\">Tell us about your work and life experiences since graduating from UCLA. </label>\n" +
    "            <input\n" +
    "                name=\"experienceAfter\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__experienceAfter\"\n" +
    "                ng-focus=\"inputFocus.experienceAfter = true\"\n" +
    "                ng-blur=\"inputFocus.experienceAfter = false\"\n" +
    "                ng-model=\"accomplishments.experienceAfter\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.experienceDoors}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__experienceDoors\">How did your study of the arts at UCLA inform or open doors to your professional life today?</label>\n" +
    "\n" +
    "            <input\n" +
    "                name=\"experienceDoors\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__experienceDoors\"\n" +
    "                ng-focus=\"inputFocus.experienceDoors = true\"\n" +
    "                ng-blur=\"inputFocus.experienceDoors = false\"\n" +
    "                ng-model=\"accomplishments.experienceDoors\" />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.experienceKnowledge}\">\n" +
    "\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__experienceKnowledge\">What piece of knowledge or advice would you share with your 18-year-old self?</label>\n" +
    "            <input\n" +
    "                name=\"experienceKnowledge\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__experienceKnowledge\"\n" +
    "                ng-focus=\"inputFocus.experienceKnowledge = true\"\n" +
    "                ng-blur=\"inputFocus.experienceKnowledge = false\"\n" +
    "                ng-model=\"accomplishments.experienceKnowledge\" />\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "        <h4 class=\"resources-connectform__input-name\">Other Comments? <small>   Feel free to share any additional thoughts or recollections. </small></h4>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.comments}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__comments\">Comments</label>\n" +
    "            <textarea\n" +
    "                name=\"comments\"\n" +
    "                rows=3\n" +
    "                class=\"resources-connectform__textarea\"\n" +
    "                id=\"resources-connectform__comments\"\n" +
    "                ng-focus=\"inputFocus.comments = true\"\n" +
    "                ng-blur=\"inputFocus.comments = false\"\n" +
    "                ng-model=\"accomplishments.comments\" ></textarea>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "        <h4 class=\"resources-connectform__input-name\">Share your work. <small>Please provide links to file sharing sites (e.g., Dropbox) where your work may be viewed or downloaded. Please provide image credits/details following each link.</small></h4>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.workLinks}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__workLinks\">Links</label>\n" +
    "            <textarea\n" +
    "                name=\"workLinks\"\n" +
    "                rows=3\n" +
    "                class=\"resources-connectform__textarea\"\n" +
    "                id=\"resources-connectform__workLinks\"\n" +
    "                ng-focus=\"inputFocus.workLinks = true\"\n" +
    "                ng-blur=\"inputFocus.workLinks = false\"\n" +
    "                ng-model=\"accomplishments.workLinks\" ></textarea>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resource-cta__item\">\n" +
    "            <div class=\"resource-cta__item__table\">\n" +
    "                <button type=\"submit\"  class=\"resource-cta__item__link\">Submit</button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "    </form>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-contactform/resource-contactform.html',
    "<h4 class=\"resources__main__section__subtitle\">{{contentTitle}}</h4>\n" +
    "<div class=\"resource-connectform resource-contactform\">\n" +
    "    <form name=\"contactForm\" ng-submit=\"submitContact()\" novalidate>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.name, 'has-error': contactForm.name.$invalid && contactForm.name.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__name\">Name<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"name\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__name\"\n" +
    "                ng-focus=\"inputFocus.name = true\"\n" +
    "                ng-blur=\"inputFocus.name = false\"\n" +
    "                ng-model=\"connect.name\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "<!--\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.address}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__address\">Address</label>\n" +
    "            <input\n" +
    "                name=\"address\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__address\"\n" +
    "                ng-focus=\"inputFocus.address = true\"\n" +
    "                ng-blur=\"inputFocus.address = false\" />\n" +
    "        </div>\n" +
    "-->\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.email, 'has-error': contactForm.email.$invalid && contactForm.email.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__email\">Email<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"email\"\n" +
    "                type=\"email\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__email\"\n" +
    "                ng-focus=\"inputFocus.email = true\"\n" +
    "                ng-blur=\"inputFocus.email = false\"\n" +
    "                ng-model=\"connect.email\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.phone, 'has-error': contactForm.phone.$invalid && contactForm.phone.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__phone\">Phone<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"phone\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__phone\"\n" +
    "                ng-focus=\"inputFocus.phone = true\"\n" +
    "                ng-blur=\"inputFocus.phone = false\"\n" +
    "                ng-model=\"connect.phone\"\n" +
    "                ng-pattern=\"/^[\\s()+-\\.]*([0-9][\\s()+-\\.]*){6,20}$/\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.message}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__phone\">Message</label>\n" +
    "            <textarea\n" +
    "                name=\"message\"\n" +
    "                class=\"resources-connectform__textarea \"\n" +
    "                id=\"resources-connectform__message\"\n" +
    "                ng-focus=\"inputFocus.message = true\"\n" +
    "                ng-blur=\"inputFocus.message = false\"\n" +
    "                ng-model=\"connect.message\">\n" +
    "            </textarea>\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resource-cta__item\">\n" +
    "            <div class=\"resource-cta__item__table\">\n" +
    "                <button type=\"submit\"  class=\"resource-cta__item__link\">Submit</button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "    </form>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-cta/resource-cta.html',
    "<div class=\"resource-cta\">\n" +
    "    <div\n" +
    "        ng-repeat=\"c in content['cta-content'] | orderBy: sortByRank\"\n" +
    "        ng-class=\"{'dark': c.style==='dark', 'last': $index % 3 === 2}\"\n" +
    "        class=\"resource-cta__item\">\n" +
    "        <div class=\"resource-cta__item__table\">\n" +
    "            <a\n" +
    "                ng-if=\"c.uiState\"\n" +
    "                ui-sref=\"{{ c.uiState }}\"\n" +
    "                class=\"resource-cta__item__link\">\n" +
    "                {{ c.title }}\n" +
    "            </a>\n" +
    "            <a\n" +
    "                ng-if=\"c.url\"\n" +
    "                href=\"{{ c.url }}\"\n" +
    "                target=\"_blank\"\n" +
    "                class=\"resource-cta__item__link\">\n" +
    "                {{ c.title }}\n" +
    "            </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-grid/resource-grid.html',
    "<h3\n" +
    "    class=\"resources__main__section__title\"\n" +
    "    ng-if=\"!hideTitle\">{{contentTitle}}</h3>\n" +
    "<div\n" +
    "    ng-if=\"gridStyle=='personGrid'\"\n" +
    "    class=\"resource-grid\">\n" +
    "    <div\n" +
    "        ng-repeat=\"section in content['grid-content'] | orderBy: sortByRank\"\n" +
    "        class=\"resource-grid--person__section\">\n" +
    "        <h4\n" +
    "            class=\"resource-grid--person__section__subtitle resource__title--rotate\"\n" +
    "            ng-class=\"{'resource-grid__section__collapse-title': section.collapsible === 'true'}\">{{section.subtitle}}</h4>\n" +
    "        <div\n" +
    "            class=\"resource-grid__section__collapse-btn\"\n" +
    "            ng-if=\"section.collapsible === 'true'\"\n" +
    "            data-open=\"{{section.collapsed === 'false'}}\">\n" +
    "        </div>\n" +
    "        <div class=\"resource-grid__section__collapse-section\">\n" +
    "            <ul class=\"column-data\">\n" +
    "                <li\n" +
    "                    ng-repeat=\"item in section.items | orderBy: sortByRank\">\n" +
    "                    <span class=\"resource-grid--person__section__item__title\">{{item.title}}</span>\n" +
    "                    <span ng-bind-html=\"item.subtitle\" class=\"resource-grid--person__section__item__subtitle\" ng-if=\"item.subtitle\"></span>\n" +
    "                    <a\n" +
    "                        ng-href=\"{{ item.linkPath }}\"\n" +
    "                        target=\"_blank\"\n" +
    "                        ng-if=\"item.linkPath\"\n" +
    "                        class=\"resource-grid--person__section__item__link\">\n" +
    "                        {{item.linkTitle}}\n" +
    "                    </a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "            <div ng-repeat=\"subsection in section.content | orderBy: sortByRank\">\n" +
    "                <h4\n" +
    "                    class=\"resource-grid__subsection-title\"\n" +
    "                    ng-bind-html=\"subsection.subtitle\"\n" +
    "                    ng-class=\"{'resource-grid__subsection__collapse-title': subsection.collapsible === 'true'}\">\n" +
    "                </h4>\n" +
    "                <div\n" +
    "                    class=\"resource-grid__subsection__collapse-btn\"\n" +
    "                    ng-if=\"subsection.collapsible === 'true'\"\n" +
    "                    data-open=\"{{subsection.collapsed === 'false'}}\">\n" +
    "                </div>\n" +
    "                <ul class=\"column-data resource-grid__subsection__collapse-section\">\n" +
    "                    <li\n" +
    "                        ng-repeat=\"subitem in subsection.items | orderBy: sortByRank\">\n" +
    "                        <span class=\"resource-grid--person__section__item__title\" ng-bind-html=\"subitem.title\" ></span>\n" +
    "                        <span ng-bind-html=\"subitem.subtitle\" class=\"resource-grid--person__section__item__subtitle\" ng-if=\"subitem.subtitle\"></span>\n" +
    "                        <a\n" +
    "                            ng-href=\"{{ subitem.linkPath }}\"\n" +
    "                            target=\"_blank\"\n" +
    "                            ng-if=\"subitem.linkPath\"\n" +
    "                            class=\"resource-grid--person__section__item__link\">\n" +
    "                            {{subitem.linkTitle}}\n" +
    "                        </a>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div\n" +
    "    ng-if=\"gridStyle=='facts'\"\n" +
    "    class=\"resource-grid\">\n" +
    "    <div\n" +
    "        ng-repeat=\"section in content | orderBy: sortByRank\"\n" +
    "        class=\"resource-grid--facts__section\">\n" +
    "        <ul class=\"column-data\">\n" +
    "            <li\n" +
    "                ng-repeat=\"item in section.items | orderBy: sortByRank\">\n" +
    "                <span class=\"resource-grid--facts__section__item__title\">{{item.title}}</span>\n" +
    "                <span ng-bind-html=\"item.subtitle\" class=\"resource-grid--facts__section__item__subtitle\"></span>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div\n" +
    "    ng-if=\"gridStyle=='twoCol'\"\n" +
    "    class=\"resource-grid\">\n" +
    "    <div\n" +
    "        ng-repeat=\"section in content\"\n" +
    "        class=\"resource-grid--two-col__section\">\n" +
    "        <div class=\"resource-grid--two-col__section__body\" ng-bind-html=\"section.body\" ></div>\n" +
    "        <div class=\"resource-grid--two-col__section__items\">\n" +
    "            <div\n" +
    "                ng-repeat=\"item in section.items\"\n" +
    "                class=\"resource-grid--two-col__section__item\">\n" +
    "                <span class=\"resource-grid--two-col__section__item__title\">{{item.title}}</span>\n" +
    "                <span ng-bind-html=\"item.subtitle\" class=\"resource-grid--two-col__section__item__subtitle\"></span>\n" +
    "                <a\n" +
    "                    ng-href=\"{{ item.linkPath }}\"\n" +
    "                    target=\"_blank\"\n" +
    "                    ng-if=\"item.linkPath\"\n" +
    "                    class=\"resource-grid--person__section__item__link\">\n" +
    "                    {{item.linkTitle}}\n" +
    "                </a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-jumpable/resource-jumpable.html',
    "<h3 class=\"resources__main__section__title\">{{contentTitle}}</h3>\n" +
    "<div class=\"resource-jumpable\">\n" +
    "    <div\n" +
    "        class=\"resource-jumpable__links\"\n" +
    "        ng-class=\"{'resource-jumpable__links--columns': columns}\">\n" +
    "        <span\n" +
    "            ng-class=\"{'resource-jumpable__link--subtitle-wrapper': content.sectionTitle}\"\n" +
    "            ng-repeat=\"content in content | orderBy: sortByRank\">\n" +
    "            <a\n" +
    "                class=\"resource-jumpable__link--subtitle\"\n" +
    "                ng-if=\"content.sectionTitle\"\n" +
    "                ng-click=\"jumpToSection(content.slug)\">{{content.sectionTitle}}</a>\n" +
    "            <a\n" +
    "                class=\"resource-jumpable__link\"\n" +
    "                ng-if=\"!content.sectionTitle\"\n" +
    "                ng-class=\"{'resource-jumpable__link--subsection': content.isSubsection}\"\n" +
    "                ng-click=\"jumpToSection(content.slug)\">{{content.title}}</a>\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"resource-jumpable__items\">\n" +
    "        <div\n" +
    "            ng-repeat=\"content in content | orderBy: sortByRank\"\n" +
    "            class=\"resource-jumpable__item\"\n" +
    "            id=\"{{content.slug}}\">\n" +
    "            <h5 class=\"resource-jumpable__item__title\">{{content.title}}</h5>\n" +
    "            <div\n" +
    "                class=\"resource-jumpable__item__body\"\n" +
    "                ng-bind-html=\"content.body | toTrusted\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-map/resource-map.html',
    "<h3 class=\"resources__main__section__title\">{{contentTitle}}</h3>\n" +
    "<div class=\"resource-map\">\n" +
    "    <div\n" +
    "        class=\"resource-map__group\"\n" +
    "        ng-repeat=\"map in content | orderBy: sortByRank\">\n" +
    "        <div class=\"resource-map__map-holder\">\n" +
    "            <div class=\"resource-map__map\">\n" +
    "                <img ng-src=\"{{map.image}}\"\n" +
    "                    ng-click=\"markerUntrack('all', $index)\"/>\n" +
    "                <span\n" +
    "                    class=\"resource-map__map__marker\"\n" +
    "                    ng-repeat=\"marker in map.markers\"\n" +
    "                    ng-style=\"{left: marker.left + '%', top: marker.top + '%'}\"\n" +
    "                    ng-class=\"{'active': markerTracker[$parent.$index][$index]}\"\n" +
    "                    ng-click=\"markerClick($index, $parent.$index)\"\n" +
    "                    ng-mouseenter=\"markerTrack($index, $parent.$index)\"\n" +
    "                    ng-mouseleave=\"markerUntrack($index, $parent.$index)\">\n" +
    "                        {{ marker.label }}\n" +
    "                        <span class=\"resource-map__map__marker__tip\">\n" +
    "                            <span class=\"resource-map__map__marker__title\" ng-bind-html=\"marker.title | toTrusted\"></span>\n" +
    "                            <span class=\"resource-map__map__marker__subtitle\" ng-bind-html=\"marker.subtitle | toTrusted\"></span>\n" +
    "                        </span>\n" +
    "                    </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"resource-map__legends\">\n" +
    "            <div\n" +
    "                class=\"resource-map__legends__location\"\n" +
    "                ng-class=\"{'active': markerTracker[$parent.$index][$index]}\"\n" +
    "                ng-click=\"markerClick($index, $parent.$index)\"\n" +
    "                ng-mouseenter=\"markerTrack($index, $parent.$index)\"\n" +
    "                ng-mouseleave=\"markerUntrack($index, $parent.$index)\"\n" +
    "                ng-repeat=\"marker in map.markers\">\n" +
    "                <span class=\"resource-map__legends__number\">{{ marker.label }}</span>\n" +
    "                <span class=\"resource-map__legends__title\" ng-bind-html=\"marker.title | toTrusted\"></span>\n" +
    "                <span class=\"resource-map__legends__subtitle\" ng-bind-html=\"marker.subtitle | toTrusted\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"resources-map-lightbox\">\n" +
    "    <div class=\"resource-map-lightbox__background\" ng-click=\"closeLightbox()\"></div>\n" +
    "    <div class=\"resources-map-lightbox__content\">\n" +
    "        <div class=\"resources-map-lightbox__content__map\">\n" +
    "            <iframe\n" +
    "              frameborder=\"0\" style=\"border:0\"\n" +
    "              ng-src=\"{{ currentLocation.gmap }}\" allowfullscreen>\n" +
    "            </iframe>\n" +
    "        </div>\n" +
    "        <div class=\"resources-map-lightbox__content__text\">\n" +
    "            <div class=\"text\" ng-bind-html=\"currentLocation.body | toTrusted\"></div>\n" +
    "            <a class=\"btn-close\" ng-click=\"closeLightbox()\">Close</a>\n" +
    "\n" +
    "            <a class=\"btn-maps\" ng-href=\"{{ currentLocation.gmap }}\" target=\"_blank\">Open in Google Maps</a>\n" +
    "        </div>\n" +
    "\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-panel/resource-panel.html',
    "<h3 class=\"resources__main__section__title\">{{contentTitle}}</h3>\n" +
    "<div class=\"resource-panel\">\n" +
    "    <div\n" +
    "        ng-repeat=\"content in content['panel-content'] | orderBy: sortByRank\"\n" +
    "        class=\"resource-panel__item\">\n" +
    "\n" +
    "        <h4\n" +
    "            class=\"resource-panel__item__subtitle resource__title--rotate\"\n" +
    "            ng-bind=\"content.subtitle\">\n" +
    "        </h4>\n" +
    "        <div class=\"resource-panel__item__image\">\n" +
    "            <img ng-src=\"{{ content.image }}\">\n" +
    "        </div>\n" +
    "        <div class=\"resource-panel__item__text\">\n" +
    "            <div\n" +
    "                class=\"resource-panel__item__text__body\"\n" +
    "                ng-bind-html=\"content.body | toTrusted\">\n" +
    "            </div>\n" +
    "            <div\n" +
    "                class=\"resource-panel__item__text__byline\"\n" +
    "                ng-bind-html=\"content.byline | toTrusted\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-post-slideshow/resource-post-slideshow.html',
    "<div class=\"resource-post-slideshow\">\n" +
    "    <h3\n" +
    "        class=\"resource-post-slideshow__title resources__main__section__title\"\n" +
    "        ng-bind=\"contentTitle\"\n" +
    "        ng-if=\"contentTitle && contentTitle != ''\">\n" +
    "    </h3>\n" +
    "    <div\n" +
    "        class=\"resource-post-slideshow__carousel\">\n" +
    "        <div\n" +
    "            class=\"resource-post-slideshow__slide\"\n" +
    "            ng-repeat=\"item in content\">\n" +
    "            <div class=\"resource-post-slideshow__slide__wrap\">\n" +
    "                <a ui-sref=\"single({slug: item.slug})\">\n" +
    "                    <div class=\"resource-post-slideshow__slide__image-wrap\">\n" +
    "                        <img\n" +
    "                            class=\"resource-post-slideshow__slide__image\"\n" +
    "                            ng-src=\"{{ item.image }}\">\n" +
    "                    </div>\n" +
    "                    <div class=\"resource-post-slideshow__info\">\n" +
    "                        <div\n" +
    "                            class=\"post__info__title\"\n" +
    "                            ng-bind=\"item.title\">\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            class=\"post__info__subtitle link1\"\n" +
    "                            ng-bind-html=\"item.subtitle\">\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            class=\"post__info__excerpt copy\"\n" +
    "                            ng-bind=\"item.summary\">\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"resource-post-slideshow__controls\">\n" +
    "        <a class=\"resource-post-slideshow__control resource-post-slideshow__control--next\">→</a>\n" +
    "        <div class=\"resource-post-slideshow__count\">\n" +
    "            <sup>{{ currentIndex }}</sup><span>/</span><sub>{{ content.length}}</sub>\n" +
    "        </div>\n" +
    "        <a class=\"resource-post-slideshow__control resource-post-slideshow__control--prev\">←</a>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-post/resource-post.html',
    "<div class=\"resource-post\">\n" +
    "    {{content}}\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-prospectiveform/resource-prospectiveform.html',
    "<h4 class=\"resources__main__section__subtitle\">UNDERGRADUATE &amp; GRADUATE INFORMATION REQUEST</h4>\n" +
    "<p>If you would like to receive more information about undergraduate and graduate programs at the UCLA School of the Arts and Architecture, please complete the following form.</p>\n" +
    "<div class=\"resource-prospectiveform resource-connectform\">\n" +
    "    <form name=\"contactForm\" ng-submit=\"submitContact()\" novalidate>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.name_first, 'has-error': contactForm.name_first.$invalid && contactForm.name_first.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__name_first\">First Name<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"name_first\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__name_first\"\n" +
    "                ng-focus=\"inputFocus.name_first = true\"\n" +
    "                ng-blur=\"inputFocus.name_first = false\"\n" +
    "                ng-model=\"contact.name_first\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.name_last, 'has-error': contactForm.name_last.$invalid && contactForm.name_last.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__name_last\">Last Name<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"name_last\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__name_last\"\n" +
    "                ng-focus=\"inputFocus.name_last = true\"\n" +
    "                ng-blur=\"inputFocus.name_last = false\"\n" +
    "                ng-model=\"contact.name_last\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label resources-connectform__label-radio\"\n" +
    "                for=\"resources-connectform__gender\">Gender</label>\n" +
    "\n" +
    "                <input\n" +
    "                    type=\"radio\"\n" +
    "                    name=\"gender\"\n" +
    "                    value=\"female\"\n" +
    "                    ng-model=\"contact.gender\"\n" +
    "                    class=\"resources-connectform__input-radio\">Female\n" +
    "                <input type=\"radio\" name=\"gender\" value=\"male\" ng-model=\"contact.gender\" class=\"resources-connectform__input-radio\">Male\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.address_street, 'has-error': contactForm.address_street.$invalid && contactForm.address_street.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__address_street\">Street Address<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"address_street\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__address_street\"\n" +
    "                ng-focus=\"inputFocus.address_street = true\"\n" +
    "                ng-blur=\"inputFocus.address_street = false\"\n" +
    "                ng-model=\"contact.address_street\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.address_city, 'has-error': contactForm.address_city.$invalid && contactForm.address_city.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__address_city\">City<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"address_city\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__address_city\"\n" +
    "                ng-focus=\"inputFocus.address_city = true\"\n" +
    "                ng-blur=\"inputFocus.address_city = false\"\n" +
    "                ng-model=\"contact.address_city\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.address_state, 'has-error': contactForm.address_state.$invalid && contactForm.address_state.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__address_state\">State/Province<span class=\"required\" ng-if='!contact.intl_address'>*</span></label>\n" +
    "            <input\n" +
    "                name=\"address_state\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__address_state\"\n" +
    "                ng-focus=\"inputFocus.address_state = true\"\n" +
    "                ng-blur=\"inputFocus.address_state = false\"\n" +
    "                ng-model=\"contact.address_state\"\n" +
    "                ng-required='!contact.intl_address' />\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.address_code, 'has-error': contactForm.address_code.$invalid && contactForm.address_code.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__address_code\">Zip/Postal Code<span class=\"required\" ng-if='!contact.intl_address'>*</span></label>\n" +
    "            <input\n" +
    "                name=\"address_code\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__address_code\"\n" +
    "                ng-focus=\"inputFocus.address_code = true\"\n" +
    "                ng-blur=\"inputFocus.address_code = false\"\n" +
    "                ng-model=\"contact.address_code\"\n" +
    "                ng-required='!contact.intl_address' />\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.address_country, 'has-error': contactForm.address_country.$invalid && contactForm.address_country.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__address_country\">Country</label>\n" +
    "            <input\n" +
    "                name=\"address_country\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__address_country\"\n" +
    "                ng-focus=\"inputFocus.address_country = true\"\n" +
    "                ng-blur=\"inputFocus.address_country = false\"\n" +
    "                ng-model=\"contact.address_country\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label resources-connectform__label-radio\"\n" +
    "                for=\"resources-connectform__intl_address\">This is an international address</label>\n" +
    "            <input\n" +
    "                type=\"checkbox\"\n" +
    "                name=\"intl_address\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__intl_addrss\"\n" +
    "                value=true\n" +
    "                ng-model=\"contact.intl_address\"\n" +
    "                class=\"resources-connectform__input\">\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label resources-connectform__label-radio\"\n" +
    "                for=\"resources-connectform__intl_student\">I am an International Student</label>\n" +
    "            <input\n" +
    "                type=\"checkbox\"\n" +
    "                name=\"intl_student\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__intl_student\"\n" +
    "                value=true\n" +
    "                ng-model=\"contact.intl_student\"\n" +
    "                class=\"resources-connectform__input\">\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.education, 'has-error': contactForm.education.$invalid && contactForm.education.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__education\">High School or College you attend:<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"education\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__education\"\n" +
    "                ng-focus=\"inputFocus.education = true\"\n" +
    "                ng-blur=\"inputFocus.education = false\"\n" +
    "                ng-model=\"contact.education\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.email, 'has-error': contactForm.email.$invalid && contactForm.email.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__email\">Email<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"email\"\n" +
    "                type=\"email\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__email\"\n" +
    "                ng-focus=\"inputFocus.email = true\"\n" +
    "                ng-blur=\"inputFocus.email = false\"\n" +
    "                ng-model=\"contact.email\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.email2, 'has-error': contactForm.email2.$invalid && contactForm.email2.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__email2\">Confirm Email<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"email2\"\n" +
    "                type=\"email2\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__email2\"\n" +
    "                ng-focus=\"inputFocus.email2 = true\"\n" +
    "                ng-blur=\"inputFocus.email2 = false\"\n" +
    "                ng-model=\"contact.email2\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.level,'has-error': contactForm.level.$invalid && contactForm.level.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label resources-connectform__label-dropdown\"\n" +
    "                for=\"resources-connectform__level\">UCLA Entry Level<span class=\"required\">*</span></label>\n" +
    "            <select\n" +
    "                class=\"resources-connectform__dropdown\"\n" +
    "                name=\"level\"\n" +
    "                ng-focus=\"inputFocus.level = true\"\n" +
    "                ng-blur=\"inputFocus.level = false\"\n" +
    "                ng-model=\"contact.level\"\n" +
    "                required>\n" +
    "                <option value=\"\">-- Select Entry level --</option>\n" +
    "                <option value=\"{{level}}\" ng-repeat=\"level in ['Freshman','Transfer','Graduate']\">{{level}}</option>\n" +
    "            </select>\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.year,'has-error': contactForm.year.$invalid && contactForm.year.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label resources-connectform__label-dropdown\"\n" +
    "                for=\"resources-connectform__year\">Entry Year<span class=\"required\">*</span></label>\n" +
    "            <select\n" +
    "                class=\"resources-connectform__dropdown\"\n" +
    "                name=\"year\"\n" +
    "                ng-focus=\"inputFocus.year = true\"\n" +
    "                ng-blur=\"inputFocus.year = false\"\n" +
    "                ng-model=\"contact.year\"\n" +
    "                required>\n" +
    "                <option value=\"\">-- Select expected year of entry --</option>\n" +
    "                <option value=\"{{year}}\" ng-repeat=\"year in [2016,2017,2018,2019,2020,2021,2022,2023,2024]\">{{year}}</option>\n" +
    "\n" +
    "            </select>\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.major,'has-error': contactForm.major.$invalid && contactForm.major.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-dropdown resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__major\">Indicate your intended major</label>\n" +
    "            <select\n" +
    "                class=\"resources-connectform__dropdown resources-connectform__dropdown-long\"\n" +
    "                name=\"major\"\n" +
    "                ng-focus=\"inputFocus.major = true\"\n" +
    "                ng-blur=\"inputFocus.major = false\"\n" +
    "                ng-model=\"contact.major\"\n" +
    "                ng-options=\"major as (major.name) for major in majors\">\n" +
    "                <option value=\"\">-- Select Major --</option>\n" +
    "\n" +
    "            </select>\n" +
    "        </div>\n" +
    "\n" +
    "        <input name=\"concentration\" ng-model=\"contact.concentration\" type=\"hidden\" />\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-repeat=\"dropdown in contact.major.dropdowns\"\n" +
    "            ng-class=\"{'active': inputFocus[dropdown.name],'has-error': contactForm[dropdown.name].$invalid && contactForm[dropdown.name].$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-dropdown resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__{{dropdown.name}}\">Indicate your intended {{dropdown.name}}</label>\n" +
    "            <select\n" +
    "                class=\"resources-connectform__dropdown resources-connectform__dropdown-long\"\n" +
    "                ng-focus=\"inputFocus[dropdown.name]= true\"\n" +
    "                ng-blur=\"inputFocus[dropdown.name] = false\"\n" +
    "                ng-model=\"contact.majors[$index]\"\n" +
    "                ng-change=\"changeConcentration($index,contact.majors[$index])\"\n" +
    "                ng-options=\"option as (option) for option in dropdown.values\"\n" +
    "                ng-init=\"changeConcentration($index,contact.majors[$index])\">\n" +
    "                <option value=\"\">-- Select {{dropdown.name}} --</option>\n" +
    "\n" +
    "            </select>\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.major_alternate,'has-error': contactForm.major_alternate.$invalid && contactForm.major_alternate.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-dropdown resources-connectform__label-long\"\n" +
    "                for=\"resources-connectform__major\">Alternate Major</label>\n" +
    "            <select\n" +
    "                class=\"resources-connectform__dropdown resources-connectform__dropdown-long\"\n" +
    "                name=\"major_alternate\"\n" +
    "                ng-focus=\"inputFocus.major_alternate = true\"\n" +
    "                ng-blur=\"inputFocus.major_alternate = false\"\n" +
    "                ng-model=\"contact.major_alternate\"\n" +
    "                ng-options=\"major as (major.name) for major in majors\">\n" +
    "                <option value=\"\">-- Select Alternate Major --</option>\n" +
    "\n" +
    "            </select>\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resource-cta__item\">\n" +
    "            <div class=\"resource-cta__item__table\">\n" +
    "                <button type=\"submit\"  class=\"resource-cta__item__link\">Submit</button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "    </form>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-slideshow/resource-slideshow.html',
    "<div class=\"resource-slideshow\">\n" +
    "    <h3\n" +
    "        class=\"resource-slideshow__title resources__main__section__title\"\n" +
    "        ng-bind=\"contentTitle\"\n" +
    "        ng-if=\"contentTitle && contentTitle != ''\">\n" +
    "    </h3>\n" +
    "    <div\n" +
    "        class=\"resource-slideshow__carousel\"\n" +
    "        data-carousel\n" +
    "        data-carousel-options=\"carouselOptions\">\n" +
    "        <div\n" +
    "            class=\"resource-slideshow__slide\"\n" +
    "            ng-repeat=\"item in content | orderBy: sortByRank\">\n" +
    "            <div\n" +
    "                class=\"resource-slideshow__title resource-text__subtitle\"\n" +
    "                ng-bind=\"item.toptitle\">\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"resource-slideshow__slide__wrap\">\n" +
    "                <div class=\"resource-post-slideshow__slide__image-wrap\">\n" +
    "                    <img\n" +
    "                        class=\"resource-post-slideshow__slide__image\"\n" +
    "                        ng-src=\"{{ item.image }}\">\n" +
    "                </div>\n" +
    "                <div class=\"resource-post-slideshow__info\">\n" +
    "                    <div\n" +
    "                        class=\"post__info__title\"\n" +
    "                        ng-bind=\"item.title\">\n" +
    "                    </div>\n" +
    "                    <div\n" +
    "                        class=\"post__info__subtitle link1\"\n" +
    "                        ng-bind=\"item.credit\">\n" +
    "                    </div>\n" +
    "                    <div\n" +
    "                        class=\"post__info__excerpt copy\"\n" +
    "                        ng-bind-html=\"item.quote\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"resource-slideshow__controls\">\n" +
    "        <a class=\"resource-slideshow__control resource-slideshow__control--next\">→</a>\n" +
    "        <div class=\"resource-slideshow__count\">\n" +
    "            <sup>{{ currentIndex }}</sup><span>/</span><sub>{{ content.length}}</sub>\n" +
    "        </div>\n" +
    "        <a class=\"resource-slideshow__control resource-slideshow__control--prev\">←</a>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-text/resource-text.html',
    "<h3\n" +
    "    class=\"resources__main__section__title\"\n" +
    "    ng-if=\"contentTitle && contentTitle != ''\"\n" +
    "    ng-bind=\"contentTitle\">\n" +
    "</h3>\n" +
    "<div class=\"resource-text\">\n" +
    "    <div\n" +
    "        class=\"resource-text__section\"\n" +
    "        ng-repeat=\"content in content['text-content'] | orderBy: sortByRank\">\n" +
    "        <h4\n" +
    "            class=\"resource-text__subtitle\"\n" +
    "            ng-bind=\"content.subtitle\">\n" +
    "        </h4>\n" +
    "        <div\n" +
    "            class=\"resource-text__body\"\n" +
    "            ng-bind-html=\"content.body | toTrusted\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-textlist/resource-textlist.html',
    "<h3 class=\"resources__main__section__title\">{{contentTitle}}</h3>\n" +
    "<div class=\"resource-text\">\n" +
    "    <div\n" +
    "        ng-repeat=\"content in content\"\n" +
    "        class=\"resource-textlist__section\">\n" +
    "        <h4 class=\"resource-textlist__section__subtitle resource__title--rotate\">{{content.subTitle}}</h4>\n" +
    "        <ul class=\"resource-textlist__section__items column-data\">\n" +
    "            <li ng-repeat=\"item in content.items\">{{item.title}}</li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-textphoto/resource-textphoto.html',
    "<h3 class=\"resources__main__section__title\" ng-if=\"contentTitle && contentTitle != ''\">{{contentTitle}}</h3>\n" +
    "<div class=\"resource-textphoto\">\n" +
    "    <div\n" +
    "        class=\"resource-textphoto__main\"\n" +
    "        ng-bind-html=\"content.photoBody\"></div>\n" +
    "    <div\n" +
    "        class=\"resource-textphoto__side\">\n" +
    "        <img\n" +
    "            class=\"resource-textphoto__side__photo\"\n" +
    "            ng-if=\"content['text-and-photo-photo']\"\n" +
    "            ng-src=\"{{content['text-and-photo-photo']}}\" />\n" +
    "        <div\n" +
    "            class=\"resource-textphoto__side__content\"\n" +
    "            ng-bind-html=\"content['text-and-photo-side']\"></div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-timeline/resource-timeline.html',
    "<h3 class=\"resources__main__section__title\">{{contentTitle}}</h3>\n" +
    "<div class=\"resource-timeline\">\n" +
    "    <div\n" +
    "        class=\"resource-timeline__event\"\n" +
    "        ng-repeat=\"content in content['timeline-content'] | orderBy: sortByRank\">\n" +
    "        <h5 class=\"resource-timeline__event__date\">{{content.date}}</h5>\n" +
    "        <img class=\"resource-timeline__event__photo\" ng-src=\"{{content.photo}}\" ng-if=\"content.photo\" />\n" +
    "        <div class=\"resource-timeline__event__body\" ng-bind-html=\"content.body\"></div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/resource-tourform/resource-tourform.html',
    "<h3 class=\"resources__main__section__title\">VISIT UCLA ARTS</h3>\n" +
    "\n" +
    "<div class=\"resource-text\">\n" +
    "    <div class=\"resource-text__section \">\n" +
    "        <h4 class=\"resource-text__subtitle \">VISIT UCLA ARTS</h4>\n" +
    "        <div class=\"resource-text__body \">\n" +
    "            <p>We would love to welcome you to the UCLA campus! We offer campus tours focusing on the visual and performing arts programs, and are also available for counseling appointments that can be scheduled in-person or by telephone/Skype.</p>\n" +
    "            <p>If you would like an individual appointment (in-person or phone/Skype), please contact <a href=\"mailto:admissions@arts.ucla.edu\">admissions@arts.ucla.edu</a> with your request.</p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"resource-text__section \">\n" +
    "        <h4 class=\"resource-text__subtitle \">UCLA ARTS CAMPUS TOUR DATES</h4>\n" +
    "        <div class=\"resource-text__body \">\n" +
    "            <p>Our campus tours calendar is below; please select a date to RSVP. A UCLA Arts representative will be on hand to discuss admissions, portfolio and audition requirements, academics, and student life. This 90-minute walking tour involves stairs, so please wear comfortable shoes. Tours meet on UCLA’s campus in front of the large torque ellipse sculpture on the lawn of the Broad Art Center.</p>\n" +
    "            <p>If you are interested in theater and film programs, please visit <a href=\"http://www.tft.ucla.edu/tours/\" target=\"_blank\">the School of Theater, Film and Television’s website</a>.<br>If you are interested in music, please visit <a href=\"http://schoolofmusic.ucla.edu/admission-to-ucla-herb-alpert-school-of-music\" target=\"_blank\">the Herb Alpert School of Music’s website</a>.</p>\n" +
    "\n" +
    "           <!--  <div ng-repeat=\"tour in tours | orderBy : 'dateObj'\">\n" +
    "                <p>\n" +
    "                    {{ tour.dateObj | date: 'fullDate' }} - {{ tour.eventData.startTime }}<br>\n" +
    "                    <a class=\"arrow-link openFormLink\" target=\"_blank\">RSVP Required </a>\n" +
    "                </p>\n" +
    "                <div class=\"tour-rsvp-form-holder\" id=\"tour-rsvp-form-holder-{{$index}}\"></div>\n" +
    "            </div> -->\n" +
    "\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "\n" +
    "<div class=\"resource-connectform resource-tourform\" id=\"tour-rsvp-form\">\n" +
    "    <form name=\"tourForm\" ng-submit=\"submitTour()\" novalidate>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.event,'has-error': tourForm.event.$invalid && tourForm.event.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label resources-connectform__label-dropdown\"\n" +
    "                for=\"resources-connectform__event\">Tour<span class=\"required\">*</span></label>\n" +
    "            <select\n" +
    "                class=\"resources-connectform__dropdown\"\n" +
    "                name=\"event\"\n" +
    "                ng-focus=\"inputFocus.event = true\"\n" +
    "                ng-blur=\"inputFocus.event = false\"\n" +
    "                ng-model=\"selectedTour.event\"\n" +
    "                id=\"tour-form__date-and-time\"\n" +
    "                required >\n" +
    "                <option value=\"\">-- Please Select a Tour Below --</option>\n" +
    "                <option ng-repeat=\"tour in tours | orderBy: 'dateObj'\" value=\"{{tour.id}}\">{{tour.title}} {{tour.eventData.startDate}} @ {{tour.eventData.startTime}}</option>\n" +
    "            </select>\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.nameFirst,'has-error': tourForm.nameFirst.$invalid && tourForm.nameFirst.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__nameFirst\">First Name<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"nameFirst\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__nameFirst\"\n" +
    "                ng-focus=\"inputFocus.nameFirst = true\"\n" +
    "                ng-blur=\"inputFocus.nameFirst = false\"\n" +
    "                ng-model=\"selectedTour.nameFirst\"\n" +
    "                required  />\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.nameLast,'has-error': tourForm.nameLast.$invalid && tourForm.nameLast.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__nameLast\">Last Name<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"nameLast\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__nameLast\"\n" +
    "                ng-focus=\"inputFocus.nameLast = true\"\n" +
    "                ng-blur=\"inputFocus.nameLast = false\"\n" +
    "                ng-model=\"selectedTour.nameLast\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.email,'has-error': tourForm.email.$invalid && tourForm.email.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label\"\n" +
    "                for=\"resources-connectform__email\">Email<span class=\"required\">*</span></label>\n" +
    "            <input\n" +
    "                name=\"email\"\n" +
    "                class=\"resources-connectform__input\"\n" +
    "                id=\"resources-connectform__email\"\n" +
    "                ng-focus=\"inputFocus.email = true\"\n" +
    "                ng-blur=\"inputFocus.email = false\"\n" +
    "                ng-model=\"selectedTour.email\"\n" +
    "                required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.attendee,'has-error': tourForm.attendee.$invalid && tourForm.attendee.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label resources-connectform__label-dropdown\"\n" +
    "                for=\"resources-connectform__attendee\">Attendee<span class=\"required\">*</span></label>\n" +
    "            <select\n" +
    "                class=\"resources-connectform__dropdown\"\n" +
    "                name=\"attendee\"\n" +
    "                ng-focus=\"inputFocus.attendee = true\"\n" +
    "                ng-blur=\"inputFocus.attendee = false\"\n" +
    "                ng-model=\"selectedTour.attendee\"\n" +
    "                required>\n" +
    "                <option value=\"\">-- Select Attendee --</option>\n" +
    "                <option value=\"Prospective-Student\">Prospective Student</option>\n" +
    "                <option value=\"Parent\">Parent</option>\n" +
    "                <option value=\"Educator\">Educator</option>\n" +
    "                <option value=\"Counselor\">Counselor</option>\n" +
    "            </select>\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.level,'has-error': tourForm.level.$invalid && tourForm.level.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label resources-connectform__label-dropdown\"\n" +
    "                for=\"resources-connectform_level\">Entry Level<span class=\"required\">*</span></label>\n" +
    "            <select\n" +
    "                class=\"resources-connectform__dropdown\"\n" +
    "                name=\"level\"\n" +
    "                ng-focus=\"inputFocus.level = true\"\n" +
    "                ng-blur=\"inputFocus.level = false\"\n" +
    "                ng-model=\"selectedTour.level\"\n" +
    "                required>\n" +
    "                <option value=\"\">-- Select Entry Level --</option>\n" +
    "                <option value=\"Freshman\">Freshman</option>\n" +
    "                <option value=\"Transfer\">Transfer</option>\n" +
    "                <option value=\"Graduate\">Graduate</option>\n" +
    "                <option value=\"Other\">Other</option>\n" +
    "            </select>\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.year,'has-error': tourForm.year.$invalid && tourForm.year.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label resources-connectform__label-dropdown\"\n" +
    "                for=\"resources-connectform__year\">Entry Year<span class=\"required\">*</span></label>\n" +
    "            <select\n" +
    "                class=\"resources-connectform__dropdown\"\n" +
    "                name=\"year\"\n" +
    "                ng-focus=\"inputFocus.year = true\"\n" +
    "                ng-blur=\"inputFocus.year = false\"\n" +
    "                ng-model=\"selectedTour.year\"\n" +
    "                required>\n" +
    "                <option value=\"\">-- Select Entry Year --</option>\n" +
    "                <option value=\"2016\">2016</option>\n" +
    "                <option value=\"2017\">2017</option>\n" +
    "                <option value=\"2018\">2018</option>\n" +
    "                <option value=\"2019\">2019</option>\n" +
    "                <option value=\"2020\">2020</option>\n" +
    "                <option value=\"2021\">2021</option>\n" +
    "                <option value=\"2022\">2022</option>\n" +
    "                <option value=\"2023\">2023</option>\n" +
    "                <option value=\"2024\">2024</option>\n" +
    "                <option value=\"2025\">2025</option>\n" +
    "\n" +
    "            </select>\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.major,'has-error': tourForm.major.$invalid && tourForm.major.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label resources-connectform__label-dropdown\"\n" +
    "                for=\"resources-connectform__major\">Intended Major<span class=\"required\">*</span></label>\n" +
    "            <select\n" +
    "                class=\"resources-connectform__dropdown\"\n" +
    "                name=\"major\"\n" +
    "                ng-focus=\"inputFocus.major = true\"\n" +
    "                ng-blur=\"inputFocus.major = false\"\n" +
    "                ng-model=\"selectedTour.major\"\n" +
    "                required>\n" +
    "                <option value=\"\">-- Select Major Department --</option>\n" +
    "                <option value=\"Architecture-and-Urban-Design\">Architecture and Urban Design</option>\n" +
    "                <option value=\"Art\">Art</option>\n" +
    "                <option value=\"Design-Media-Arts\">Design | Media Arts</option>\n" +
    "                <option value=\"Dance\">Dance</option>\n" +
    "                <option value=\"World-Arts-and-Culture\">World Arts and Culture</option>\n" +
    "            </select>\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources-connectform__input-group\"\n" +
    "            ng-class=\"{'active': inputFocus.guests,'has-error': tourForm.guests.$invalid && tourForm.guests.$touched}\">\n" +
    "            <label\n" +
    "                class=\"resources-connectform__label-long resources-connectform__label-dropdown\"\n" +
    "                for=\"resources-connectform__guests\">Guests Attending<span class=\"required\">*</span> <small>(For Parties of six (6) or more please call 310.825.8981)</small></label>\n" +
    "            <select\n" +
    "                class=\"resources-connectform__dropdown\"\n" +
    "                name=\"guests\"\n" +
    "                id=\"tour-form__guests\"\n" +
    "                ng-focus=\"inputFocus.guests = true\"\n" +
    "                ng-blur=\"inputFocus.guests = false\"\n" +
    "                ng-model=\"selectedTour.guests\"\n" +
    "                required>\n" +
    "                <option value=\"\">-- Select Guests Attending --</option>\n" +
    "                <option value=\"1\">Myself</option>\n" +
    "                <option value=\"2\">Myself + One (1) Guest</option>\n" +
    "                <option value=\"3\">Myself + Two (2) Guests</option>\n" +
    "                <option value=\"4\">Myself + Three (3) Guests</option>\n" +
    "                <option value=\"5\">Myself + Four (4) Guests</option>\n" +
    "            </select>\n" +
    "        </div>\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resource-cta__item\">\n" +
    "            <div class=\"resource-cta__item__table\">\n" +
    "                <button type=\"submit\"  class=\"resource-cta__item__link\">Submit</button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "    </form>\n" +
    "</div>\n" +
    "\n"
  );


  $templateCache.put('components/resources-nav/resources-nav.html',
    "<ul\n" +
    "    ng-class=\"{\n" +
    "        'resources__side-nav__main' : position == 'sidenav',\n" +
    "        'global-header-mobile__list' : position == 'mobile',\n" +
    "        'menu__list' : position == 'globalnav'\n" +
    "    }\">\n" +
    "    <li\n" +
    "        ng-repeat=\"item in nav\"\n" +
    "        ng-class=\"{\n" +
    "            'resources__side-nav__main__link' : position == 'sidenav',\n" +
    "            'global-header-mobile__list__item' : position == 'mobile',\n" +
    "            'menu__list__item' : position == 'globalnav'\n" +
    "        }\">\n" +
    "        <a\n" +
    "            ui-sref=\"home.resources({slug:'{{item.slug}}'})\"\n" +
    "            ui-sref-opts=\"{inherit: false}\"\n" +
    "            ng-class=\"{\n" +
    "                'global-header-mobile__list__item__link link1' : position == 'mobile',\n" +
    "                'menu__list__item__link link1' : position == 'globalnav',\n" +
    "                'active': currentSlug == item.slug\n" +
    "            }\">{{item.title}}</a>\n" +
    "                <ul\n" +
    "                    ng-if=\"childnav[item.id].length > 0\"\n" +
    "                    ng-class=\"{\n" +
    "                        'resources__side-nav__main__sub' : position == 'sidenav',\n" +
    "                        'menu__list' : position == 'globalnav'\n" +
    "                    }\">\n" +
    "                    <li\n" +
    "                        ng-repeat=\"childitem in childnav[item.id]\"\n" +
    "                        ng-class=\"{\n" +
    "                            'resources__side-nav__main__sub__link' : position == 'sidenav'\n" +
    "                        }\">\n" +
    "                        <a\n" +
    "                            ui-sref=\"home.resources({slug:'{{childitem.slug}}'})\"\n" +
    "                            ui-sref-opts=\"{inherit: false}\"\n" +
    "                            ng-class=\"{\n" +
    "                                'global-header-mobile__list__item__link link1' : position == 'mobile',\n" +
    "                                'menu__list__item__link link1' : position == 'globalnav',\n" +
    "                                'active': currentSlug == childitem.slug\n" +
    "                            }\">{{childitem.title}}</a>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "    </li>\n" +
    "</ul>\n"
  );


  $templateCache.put('components/search/search.html',
    "<div\n" +
    "    modal\n" +
    "    modal-close=\"ctrl.close\"\n" +
    "    class=\"search\"\n" +
    "    ng-class=\"['state-'+currentState]\">\n" +
    "    <a\n" +
    "        class=\"search__close link1\"\n" +
    "        data-state=\"\"\n" +
    "        ng-click=\"onCloseClick()\">\n" +
    "        Close\n" +
    "    </a>\n" +
    "    <div class=\"search__wrap\">\n" +
    "        <div class=\"search__form\">\n" +
    "            <div class=\"search__form__title\">Search</div>\n" +
    "            <span\n" +
    "                class=\"search__form__blinking-cursor\"\n" +
    "                ng-class=\"{'hide': searchModel.length > 0 || focused}\"></span>\n" +
    "            <input\n" +
    "                ng-model=\"searchModel\"\n" +
    "                class=\"search__form__field\"\n" +
    "                ng-class=\"{'has-content' : (searchModel.length > 0 || focused) }\"\n" +
    "                ng-focus=\"focused = true\"\n" +
    "                ng-blur=\"focused = false\"\n" +
    "                placeholder=\"Type To Search\" />\n" +
    "        </div>\n" +
    "        <div class=\"search__list\">\n" +
    "            <h4 class=\"search__list__count\">{{results.length}} result{{results.length == 1 ? \"\" : \"s\"}} found {{loadingText}}</h4>\n" +
    "            <ol class=\"search__list__items\">\n" +
    "                <li\n" +
    "                    class=\"search__list__item\"\n" +
    "                    ng-repeat=\"item in results\">\n" +
    "                    <a\n" +
    "                        ng-if=\"item.type != 'resource'\"\n" +
    "                        class=\"search__list__item__link\"\n" +
    "                        ui-sref=\"single({slug: item.slug})\">{{item.title}}</a>\n" +
    "                    <a\n" +
    "                        ng-if=\"item.type == 'resource'\"\n" +
    "                        class=\"search__list__item__link\"\n" +
    "                        ui-sref=\"home.resources({slug: item.slug, section: item.section})\">{{item.title}}</a>\n" +
    "\n" +
    "                    <h5 ng-if=\"item.category\"><span ng-if=\"item.type == 'resource'\">UCLA Arts Resources - </span>{{item.category}}</h5>\n" +
    "\n" +
    "                    <div\n" +
    "                        class=\"info\"()\n" +
    "                        ng-if=\"(item.summary && item.summary != '') || (item.body && item.body != '')\"\n" +
    "                        ng-bind-html=\"item.summary || item.body | limitTo: 400\">\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/side-nav/side-nav.html',
    "<a\n" +
    "    class=\"side-nav\"\n" +
    "    ng-class=\"{'side-nav--right': sideNavSide === 'right', 'side-nav--left': sideNavSide === 'left'}\"\n" +
    "    ui-sref=\"{{ sideNavSref }}\">\n" +
    "    <span\n" +
    "        class=\"side-nav__text\"\n" +
    "        ng-bind=\"sideNavText\">\n" +
    "    </span>\n" +
    "</a>\n"
  );


  $templateCache.put('index.html',
    "<!--[if IE ]><![endif]-->\n" +
    "<!DOCTYPE html>\n" +
    "<!--[if IE 8 ]> <html class=\"no-js lt-ie9 ie8\" lang=\"en\" data-ng-app=\"ua5App\" data-ng-cloak data-app> <![endif]-->\n" +
    "<!--[if IE 9 ]> <html class=\"no-js lt-ie10 ie9\" lang=\"en\" data-ng-app=\"ua5App\" data-ng-cloak data-app> <![endif]-->\n" +
    "<!--[if (gte IE 10)|!(IE)]><!--> <html class=\"no-js\" lang=\"en\" data-ng-app=\"ua5App\" ng-strict-di=\"true\" data-ng-cloak data-app><!--<![endif]-->\n" +
    "    <head data-ng-controller=\"MetaCtrl\">\n" +
    "        <meta charset=\"utf-8\">\n" +
    "        <meta name=\"fragment\" content=\"!\">\n" +
    "        <base href=\"/\">\n" +
    "\n" +
    "        <!--[if lt IE 9]>\n" +
    "          <script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n" +
    "        <![endif]-->\n" +
    "\n" +
    "        <script src=\"bower_components/angular/angular.js\"></script>\n" +
    "        <link\n" +
    "            href=\"_build/app.css?v=1492189298\"\n" +
    "            rel=\"stylesheet\"\n" +
    "            type=\"text/css\">\n" +
    "        <meta\n" +
    "            name=\"viewport\"\n" +
    "            content=\"width=device-width, initial-scale=1.0, user-scalable=no\">\n" +
    "        <title ng-bind=\"meta.prefix + meta.title + meta.suffix \">\n" +
    "            UCLA Arts: School of the Arts and Architecture\n" +
    "        </title>\n" +
    "        <meta\n" +
    "            property=\"og:title\"\n" +
    "            ng-attr-content=\"{{ meta.prefix }}{{ meta.title }}{{ meta.suffix }}\"\n" +
    "            content=\"UCLA Arts: School of the Arts and Architecture\">\n" +
    "        <meta\n" +
    "            name=\"description\"\n" +
    "            ng-attr-content=\"{{ meta.description }}\"\n" +
    "            content=\"Introduction by the Dean, calendar of events, admissions information and student services.\">\n" +
    "        <meta\n" +
    "            property=\"og:description\"\n" +
    "            ng-attr-content=\"{{ meta.description }}\"\n" +
    "            content=\"Introduction by the Dean, calendar of events, admissions information and student services.\">\n" +
    "        <meta\n" +
    "            property=\"og:image\"\n" +
    "            ng-attr-content=\"{{ meta.image }}\"\n" +
    "            content=\"http://di79x7a4whson.cloudfront.net/assets/img/ucla-arts-share-img.jpg\">\n" +
    "        <meta\n" +
    "            property=\"og:site_name\"\n" +
    "            content=\"UCLA Arts: School of the Arts and Architecture\">\n" +
    "        <meta\n" +
    "            property=\"og:url\"\n" +
    "            ng-attr-content=\"{{ meta.ogUrl }}\"\n" +
    "            content=\"http://arts.ucla.edu\">\n" +
    "        <meta\n" +
    "            property=\"og:type\"\n" +
    "            content=\"website\">\n" +
    "        <meta\n" +
    "            name=\"twitter:card\"\n" +
    "            content=\"summary_large_image\">\n" +
    "        <meta\n" +
    "            name=\"twitter:site\"\n" +
    "            content=\"@UCLAarts\">\n" +
    "        <meta\n" +
    "            name=\"twitter:title\"\n" +
    "            ng-attr-content=\"{{ meta.prefix }}{{ meta.title }}{{ meta.suffix }}\"\n" +
    "            content=\"UCLA Arts: School of the Arts and Architecture\">\n" +
    "        <meta\n" +
    "            property=\"twitter:image\"\n" +
    "            ng-attr-content=\"{{ meta.image }}\"\n" +
    "            content=\"http://di79x7a4whson.cloudfront.net/assets/img/ucla-arts-share-img.jpg\">\n" +
    "        <meta\n" +
    "            property=\"twitter:description\"\n" +
    "            ng-attr-content=\"{{ meta.description }}\"\n" +
    "            content=\"Introduction by the Dean, calendar of events, admissions information and student services.\">\n" +
    "        <link\n" +
    "            href=\"assets/img/favicon.ico\"\n" +
    "            rel=\"icon\"\n" +
    "            type=\"image/png\">\n" +
    "        <script>\n" +
    "            //-- Google Analytics\n" +
    "            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n" +
    "            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n" +
    "            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n" +
    "            })(window,document,'script','//www.google-analytics.com/analytics.js','ga');\n" +
    "            ga('create', 'UA-1965480-1', 'auto');\n" +
    "            var _gaq = _gaq || [];\n" +
    "            _gaq.push(['_setDomainName', 'none']);\n" +
    "        </script>\n" +
    "        <!-- Facebook Pixel Code -->\n" +
    "        <script>\n" +
    "            !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n" +
    "            n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;\n" +
    "            n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;\n" +
    "            t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,\n" +
    "            document,'script','https://connect.facebook.net/en_US/fbevents.js');\n" +
    "            fbq('init', '1029684393768296');\n" +
    "            fbq('track', \"PageView\");\n" +
    "        </script>\n" +
    "        <noscript><img height=\"1\" width=\"1\" style=\"display:none\"\n" +
    "        src=\"https://www.facebook.com/tr?id=1029684393768296&ev=PageView&noscript=1\"\n" +
    "        /></noscript>\n" +
    "        <!-- End Facebook Pixel Code -->\n" +
    "    </head>\n" +
    "    <body>\n" +
    "        <div id=\"fb-root\"></div>\n" +
    "        <div\n" +
    "            side-nav\n" +
    "            side-nav-text=\"UCLA Arts Resources\"\n" +
    "            side-nav-sref=\"home.resources({slug:'about'})\"\n" +
    "            side-nav-side=\"right\">\n" +
    "        </div>\n" +
    "        <div\n" +
    "            side-nav\n" +
    "            side-nav-text=\"UCLA Arts Community\"\n" +
    "            side-nav-sref=\"home.community\"\n" +
    "            side-nav-side=\"left\">\n" +
    "        </div>\n" +
    "        <div global-header></div>\n" +
    "        <div global-header-mobile></div>\n" +
    "        <div ui-view ng-animate=\"'view'\"></div>\n" +
    "        <script src=\"assets/js/livereload.js\"></script>\n" +
    "        <script src=\"bower_components/jquery/dist/jquery.js\"></script>\n" +
    "        <script src=\"bower_components/angular-animate/angular-animate.js\"></script>\n" +
    "        <script src=\"bower_components/angular-touch/angular-touch.js\"></script>\n" +
    "        <script src=\"bower_components/angular-resource/angular-resource.js\"></script>\n" +
    "        <script src=\"bower_components/angular-sanitize/angular-sanitize.js\"></script>\n" +
    "        <script src=\"bower_components/angular-ui-router/release/angular-ui-router.js\"></script>\n" +
    "        <script src=\"bower_components/modernizr/modernizr.js\"></script>\n" +
    "        <script src=\"bower_components/underscore/underscore.js\"></script>\n" +
    "        <script src=\"bower_components/greensock/src/uncompressed/plugins/ScrollToPlugin.js\"></script>\n" +
    "        <script src=\"bower_components/greensock/src/uncompressed/TweenMax.js\"></script>\n" +
    "        <script src=\"bower_components/angular-modal-service/dst/angular-modal-service.js\"></script>\n" +
    "        <script src=\"bower_components/matthewlein-jQuery-widowFix/js/jquery.widowFix-1.3.2.js\"></script>\n" +
    "        <script src=\"bower_components/imagesloaded/imagesloaded.pkgd.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-loading-bar/build/loading-bar.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-scroll/angular-scroll.min.js\"></script>\n" +
    "        <script src=\"bower_components/jQuery-linkify/dist/jquery.linkify.min.js\"></script>\n" +
    "        <script src=\"bower_components/ngInfiniteScroll/build/ng-infinite-scroll.min.js\"></script>\n" +
    "        <script src=\"bower_components/suite/suite.js\"></script>\n" +
    "        <script src=\"bower_components/slick-carousel/slick/slick.min.js\"></script>\n" +
    "        <script src=\"bower_components/suite/components/carousel/carousel.js\"></script>\n" +
    "        <script src=\"bower_components/suite/factories/lock-scroll.js\"></script>\n" +
    "        <script src=\"bower_components/suite/factories/strings.js\"></script>\n" +
    "        <script src=\"bower_components/angulartics/dist/angulartics.min.js\"></script>\n" +
    "        <script src=\"bower_components/angulartics-google-analytics/dist/angulartics-google-analytics.min.js\"></script>\n" +
    "        <script src=\"bower_components/scrollreveal/scrollreveal.js\"></script>\n" +
    "\n" +
    "        <script src=\"app.js\"></script>\n" +
    "\n" +
    "        <script src=\"filters/to-trusted.js\"></script>\n" +
    "        <script src=\"filters/dashes-to-spaces.js\"></script>\n" +
    "        <script src=\"filters/html-to-plaintext.js\"></script>\n" +
    "        <script src=\"filters/spaces-to-plus.js\"></script>\n" +
    "        <script src=\"filters/date-for-google.js\"></script>\n" +
    "        <script src=\"resources/posts.js\"></script>\n" +
    "        <script src=\"resources/resources.js\"></script>\n" +
    "        <script src=\"resources/social-posts.js\"></script>\n" +
    "        <script src=\"resources/search.js\"></script>\n" +
    "        <script src=\"resources/forms.js\"></script>\n" +
    "        <script src=\"components/global-header/global-header.js\"></script>\n" +
    "        <script src=\"components/global-header-mobile/global-header-mobile.js\"></script>\n" +
    "        <script src=\"components/social/email.js\"></script>\n" +
    "        <script src=\"components/social/facebook.js\"></script>\n" +
    "        <script src=\"components/social/twitter.js\"></script>\n" +
    "        <script src=\"components/posts/posts.js\"></script>\n" +
    "        <script src=\"components/side-nav/side-nav.js\"></script>\n" +
    "        <script src=\"components/search/search.js\"></script>\n" +
    "        <script src=\"components/dropdown/dropdown.js\"></script>\n" +
    "        <script src=\"components/modal/modal.js\"></script>\n" +
    "        <script src=\"components/menu/menu.js\"></script>\n" +
    "        <script src=\"components/posts-filter/posts-filter.js\"></script>\n" +
    "        <script src=\"components/post/post.js\"></script>\n" +
    "        <script src=\"components/calendar-events/calendar-events.js\"></script>\n" +
    "        <script src=\"components/select-autowidth/select-autowidth.js\"></script>\n" +
    "        <script src=\"components/slide-in/slide-in.js\"></script>\n" +
    "        <script src=\"components/linkify/linkify.js\"></script>\n" +
    "        <script src=\"components/scroll-reveal/scroll-reveal.js\"></script>\n" +
    "        <script src=\"components/resource-text/resource-text.js\"></script>\n" +
    "        <script src=\"components/resource-textlist/resource-textlist.js\"></script>\n" +
    "        <script src=\"components/resource-timeline/resource-timeline.js\"></script>\n" +
    "        <script src=\"components/resource-grid/resource-grid.js\"></script>\n" +
    "        <script src=\"components/resource-cta/resource-cta.js\"></script>\n" +
    "        <script src=\"components/resource-panel/resource-panel.js\"></script>\n" +
    "        <script src=\"components/resource-tourform/resource-tourform.js\"></script>\n" +
    "        <script src=\"components/resource-contactform/resource-contactform.js\"></script>\n" +
    "        <script src=\"components/resource-connectform/resource-connectform.js\"></script>\n" +
    "        <script src=\"components/resource-prospectiveform/resource-prospectiveform.js\"></script>\n" +
    "        <script src=\"components/resource-jumpable/resource-jumpable.js\"></script>\n" +
    "        <script src=\"components/resource-textphoto/resource-textphoto.js\"></script>\n" +
    "        <script src=\"components/resource-map/resource-map.js\"></script>\n" +
    "        <script src=\"components/resource-slideshow/resource-slideshow.js\"></script>\n" +
    "        <script src=\"components/resource-post-slideshow/resource-post-slideshow.js\"></script>\n" +
    "        <script src=\"components/scroll-progress-bar/scroll-progress-bar.js\"></script>\n" +
    "        <script src=\"components/resources-nav/resources-nav.js\"></script>\n" +
    "\n" +
    "        <script src=\"states/home/home.js\"></script>\n" +
    "        <script src=\"states/resources/resources.js\"></script>\n" +
    "        <script src=\"states/community/community.js\"></script>\n" +
    "        <script src=\"states/single/single.js\"></script>\n" +
    "        <script src=\"states/calendar/calendar.js\"></script>\n" +
    "    </body>\n" +
    "</html>\n"
  );


  $templateCache.put('index.unprocessed.html',
    "<!--[if IE ]><![endif]-->\n" +
    "<!DOCTYPE html>\n" +
    "<!--[if IE 8 ]> <html class=\"no-js lt-ie9 ie8\" lang=\"en\" data-ng-app=\"ua5App\" data-ng-cloak data-app> <![endif]-->\n" +
    "<!--[if IE 9 ]> <html class=\"no-js lt-ie10 ie9\" lang=\"en\" data-ng-app=\"ua5App\" data-ng-cloak data-app> <![endif]-->\n" +
    "<!--[if (gte IE 10)|!(IE)]><!--> <html class=\"no-js\" lang=\"en\" data-ng-app=\"ua5App\" ng-strict-di=\"true\" data-ng-cloak data-app><!--<![endif]-->\n" +
    "    <head data-ng-controller=\"MetaCtrl\">\n" +
    "        <meta charset=\"utf-8\">\n" +
    "        <meta name=\"fragment\" content=\"!\">\n" +
    "        <base href=\"/\">\n" +
    "\n" +
    "        <!--[if lt IE 9]>\n" +
    "          <script src=\"//html5shiv.googlecode.com/svn/trunk/html5.js\"></script>\n" +
    "        <![endif]-->\n" +
    "\n" +
    "        <!-- @if PRODUCTION='false' -->\n" +
    "        <script src=\"bower_components/angular/angular.js\"></script>\n" +
    "        <!-- @endif -->\n" +
    "\n" +
    "        <link\n" +
    "            href=\"_build/app.css?v=<!-- @echo VERSION -->\"\n" +
    "            rel=\"stylesheet\"\n" +
    "            type=\"text/css\">\n" +
    "        <meta\n" +
    "            name=\"viewport\"\n" +
    "            content=\"width=device-width, initial-scale=1.0, user-scalable=no\">\n" +
    "        <title ng-bind=\"meta.prefix + meta.title + meta.suffix \">\n" +
    "            UCLA Arts: School of the Arts and Architecture\n" +
    "        </title>\n" +
    "        <meta\n" +
    "            property=\"og:title\"\n" +
    "            ng-attr-content=\"{{ meta.prefix }}{{ meta.title }}{{ meta.suffix }}\"\n" +
    "            content=\"UCLA Arts: School of the Arts and Architecture\">\n" +
    "        <meta\n" +
    "            name=\"description\"\n" +
    "            ng-attr-content=\"{{ meta.description }}\"\n" +
    "            content=\"Introduction by the Dean, calendar of events, admissions information and student services.\">\n" +
    "        <meta\n" +
    "            property=\"og:description\"\n" +
    "            ng-attr-content=\"{{ meta.description }}\"\n" +
    "            content=\"Introduction by the Dean, calendar of events, admissions information and student services.\">\n" +
    "        <meta\n" +
    "            property=\"og:image\"\n" +
    "            ng-attr-content=\"{{ meta.image }}\"\n" +
    "            content=\"http://di79x7a4whson.cloudfront.net/assets/img/ucla-arts-share-img.jpg\">\n" +
    "        <meta\n" +
    "            property=\"og:site_name\"\n" +
    "            content=\"UCLA Arts: School of the Arts and Architecture\">\n" +
    "        <meta\n" +
    "            property=\"og:url\"\n" +
    "            ng-attr-content=\"{{ meta.ogUrl }}\"\n" +
    "            content=\"http://arts.ucla.edu\">\n" +
    "        <meta\n" +
    "            property=\"og:type\"\n" +
    "            content=\"website\">\n" +
    "        <meta\n" +
    "            name=\"twitter:card\"\n" +
    "            content=\"summary_large_image\">\n" +
    "        <meta\n" +
    "            name=\"twitter:site\"\n" +
    "            content=\"@UCLAarts\">\n" +
    "        <meta\n" +
    "            name=\"twitter:title\"\n" +
    "            ng-attr-content=\"{{ meta.prefix }}{{ meta.title }}{{ meta.suffix }}\"\n" +
    "            content=\"UCLA Arts: School of the Arts and Architecture\">\n" +
    "        <meta\n" +
    "            property=\"twitter:image\"\n" +
    "            ng-attr-content=\"{{ meta.image }}\"\n" +
    "            content=\"http://di79x7a4whson.cloudfront.net/assets/img/ucla-arts-share-img.jpg\">\n" +
    "        <meta\n" +
    "            property=\"twitter:description\"\n" +
    "            ng-attr-content=\"{{ meta.description }}\"\n" +
    "            content=\"Introduction by the Dean, calendar of events, admissions information and student services.\">\n" +
    "        <link\n" +
    "            href=\"assets/img/favicon.ico\"\n" +
    "            rel=\"icon\"\n" +
    "            type=\"image/png\">\n" +
    "        <script>\n" +
    "            //-- Google Analytics\n" +
    "            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n" +
    "            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n" +
    "            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n" +
    "            })(window,document,'script','//www.google-analytics.com/analytics.js','ga');\n" +
    "            ga('create', 'UA-1965480-1', 'auto');\n" +
    "            var _gaq = _gaq || [];\n" +
    "            _gaq.push(['_setDomainName', 'none']);\n" +
    "        </script>\n" +
    "        <!-- Facebook Pixel Code -->\n" +
    "        <script>\n" +
    "            !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n" +
    "            n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;\n" +
    "            n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;\n" +
    "            t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,\n" +
    "            document,'script','https://connect.facebook.net/en_US/fbevents.js');\n" +
    "            fbq('init', '1029684393768296');\n" +
    "            fbq('track', \"PageView\");\n" +
    "        </script>\n" +
    "        <noscript><img height=\"1\" width=\"1\" style=\"display:none\"\n" +
    "        src=\"https://www.facebook.com/tr?id=1029684393768296&ev=PageView&noscript=1\"\n" +
    "        /></noscript>\n" +
    "        <!-- End Facebook Pixel Code -->\n" +
    "    </head>\n" +
    "    <body>\n" +
    "        <div id=\"fb-root\"></div>\n" +
    "        <div\n" +
    "            side-nav\n" +
    "            side-nav-text=\"UCLA Arts Resources\"\n" +
    "            side-nav-sref=\"home.resources({slug:'about'})\"\n" +
    "            side-nav-side=\"right\">\n" +
    "        </div>\n" +
    "        <div\n" +
    "            side-nav\n" +
    "            side-nav-text=\"UCLA Arts Community\"\n" +
    "            side-nav-sref=\"home.community\"\n" +
    "            side-nav-side=\"left\">\n" +
    "        </div>\n" +
    "        <div global-header></div>\n" +
    "        <div global-header-mobile></div>\n" +
    "        <div ui-view ng-animate=\"'view'\"></div>\n" +
    "        <!-- @if PRODUCTION='true' -->\n" +
    "        <script src=\"_build/vendor.js?v=<!-- @echo VERSION -->\"></script>\n" +
    "        <script src=\"_build/app.js?v=<!-- @echo VERSION -->\"></script>\n" +
    "        <!-- @endif -->\n" +
    "\n" +
    "        <!-- @if PRODUCTION='false' -->\n" +
    "        <script src=\"assets/js/livereload.js\"></script>\n" +
    "        <script src=\"bower_components/jquery/dist/jquery.js\"></script>\n" +
    "        <script src=\"bower_components/angular-animate/angular-animate.js\"></script>\n" +
    "        <script src=\"bower_components/angular-touch/angular-touch.js\"></script>\n" +
    "        <script src=\"bower_components/angular-resource/angular-resource.js\"></script>\n" +
    "        <script src=\"bower_components/angular-sanitize/angular-sanitize.js\"></script>\n" +
    "        <script src=\"bower_components/angular-ui-router/release/angular-ui-router.js\"></script>\n" +
    "        <script src=\"bower_components/modernizr/modernizr.js\"></script>\n" +
    "        <script src=\"bower_components/underscore/underscore.js\"></script>\n" +
    "        <script src=\"bower_components/greensock/src/uncompressed/plugins/ScrollToPlugin.js\"></script>\n" +
    "        <script src=\"bower_components/greensock/src/uncompressed/TweenMax.js\"></script>\n" +
    "        <script src=\"bower_components/angular-modal-service/dst/angular-modal-service.js\"></script>\n" +
    "        <script src=\"bower_components/matthewlein-jQuery-widowFix/js/jquery.widowFix-1.3.2.js\"></script>\n" +
    "        <script src=\"bower_components/imagesloaded/imagesloaded.pkgd.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-loading-bar/build/loading-bar.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-scroll/angular-scroll.min.js\"></script>\n" +
    "        <script src=\"bower_components/jQuery-linkify/dist/jquery.linkify.min.js\"></script>\n" +
    "        <script src=\"bower_components/ngInfiniteScroll/build/ng-infinite-scroll.min.js\"></script>\n" +
    "        <script src=\"bower_components/suite/suite.js\"></script>\n" +
    "        <script src=\"bower_components/slick-carousel/slick/slick.min.js\"></script>\n" +
    "        <script src=\"bower_components/suite/components/carousel/carousel.js\"></script>\n" +
    "        <script src=\"bower_components/suite/factories/lock-scroll.js\"></script>\n" +
    "        <script src=\"bower_components/suite/factories/strings.js\"></script>\n" +
    "        <script src=\"bower_components/angulartics/dist/angulartics.min.js\"></script>\n" +
    "        <script src=\"bower_components/angulartics-google-analytics/dist/angulartics-google-analytics.min.js\"></script>\n" +
    "        <script src=\"bower_components/scrollreveal/scrollreveal.js\"></script>\n" +
    "\n" +
    "        <script src=\"app.js\"></script>\n" +
    "\n" +
    "        <script src=\"filters/to-trusted.js\"></script>\n" +
    "        <script src=\"filters/dashes-to-spaces.js\"></script>\n" +
    "        <script src=\"filters/html-to-plaintext.js\"></script>\n" +
    "        <script src=\"filters/spaces-to-plus.js\"></script>\n" +
    "        <script src=\"filters/date-for-google.js\"></script>\n" +
    "        <script src=\"resources/posts.js\"></script>\n" +
    "        <script src=\"resources/resources.js\"></script>\n" +
    "        <script src=\"resources/social-posts.js\"></script>\n" +
    "        <script src=\"resources/search.js\"></script>\n" +
    "        <script src=\"resources/forms.js\"></script>\n" +
    "        <script src=\"components/global-header/global-header.js\"></script>\n" +
    "        <script src=\"components/global-header-mobile/global-header-mobile.js\"></script>\n" +
    "        <script src=\"components/social/email.js\"></script>\n" +
    "        <script src=\"components/social/facebook.js\"></script>\n" +
    "        <script src=\"components/social/twitter.js\"></script>\n" +
    "        <script src=\"components/posts/posts.js\"></script>\n" +
    "        <script src=\"components/side-nav/side-nav.js\"></script>\n" +
    "        <script src=\"components/search/search.js\"></script>\n" +
    "        <script src=\"components/dropdown/dropdown.js\"></script>\n" +
    "        <script src=\"components/modal/modal.js\"></script>\n" +
    "        <script src=\"components/menu/menu.js\"></script>\n" +
    "        <script src=\"components/posts-filter/posts-filter.js\"></script>\n" +
    "        <script src=\"components/post/post.js\"></script>\n" +
    "        <script src=\"components/calendar-events/calendar-events.js\"></script>\n" +
    "        <script src=\"components/select-autowidth/select-autowidth.js\"></script>\n" +
    "        <script src=\"components/slide-in/slide-in.js\"></script>\n" +
    "        <script src=\"components/linkify/linkify.js\"></script>\n" +
    "        <script src=\"components/scroll-reveal/scroll-reveal.js\"></script>\n" +
    "        <script src=\"components/resource-text/resource-text.js\"></script>\n" +
    "        <script src=\"components/resource-textlist/resource-textlist.js\"></script>\n" +
    "        <script src=\"components/resource-timeline/resource-timeline.js\"></script>\n" +
    "        <script src=\"components/resource-grid/resource-grid.js\"></script>\n" +
    "        <script src=\"components/resource-cta/resource-cta.js\"></script>\n" +
    "        <script src=\"components/resource-panel/resource-panel.js\"></script>\n" +
    "        <script src=\"components/resource-tourform/resource-tourform.js\"></script>\n" +
    "        <script src=\"components/resource-contactform/resource-contactform.js\"></script>\n" +
    "        <script src=\"components/resource-connectform/resource-connectform.js\"></script>\n" +
    "        <script src=\"components/resource-prospectiveform/resource-prospectiveform.js\"></script>\n" +
    "        <script src=\"components/resource-jumpable/resource-jumpable.js\"></script>\n" +
    "        <script src=\"components/resource-textphoto/resource-textphoto.js\"></script>\n" +
    "        <script src=\"components/resource-map/resource-map.js\"></script>\n" +
    "        <script src=\"components/resource-slideshow/resource-slideshow.js\"></script>\n" +
    "        <script src=\"components/resource-post-slideshow/resource-post-slideshow.js\"></script>\n" +
    "        <script src=\"components/scroll-progress-bar/scroll-progress-bar.js\"></script>\n" +
    "        <script src=\"components/resources-nav/resources-nav.js\"></script>\n" +
    "\n" +
    "        <script src=\"states/home/home.js\"></script>\n" +
    "        <script src=\"states/resources/resources.js\"></script>\n" +
    "        <script src=\"states/community/community.js\"></script>\n" +
    "        <script src=\"states/single/single.js\"></script>\n" +
    "        <script src=\"states/calendar/calendar.js\"></script>\n" +
    "        <!-- @endif -->\n" +
    "\n" +
    "    </body>\n" +
    "</html>\n"
  );


  $templateCache.put('states/calendar/calendar.html',
    "<div class=\"calendar\">\n" +
    "    <div class=\"clndr-container\">\n" +
    "        <div class=\"posts-filter\">\n" +
    "            <div class=\"posts-filter__a\">\n" +
    "                <div\n" +
    "                    class=\"posts-filter__dropdown-wrapper\"\n" +
    "                    id=\"clndr-month__dropdown\">\n" +
    "                    <ul\n" +
    "                        class=\"dropdown-select__menu\"\n" +
    "                        ng-mouseleave=\"mouseOver.calendarDropdown = false; showMonthsDropdown(false);\"\n" +
    "                        ng-mouseenter=\"mouseOver.calendarDropdown = true\"\n" +
    "                        ng-click=\"mouseOver.calendarDropdown = true\"\n" +
    "                        ng-class=\"{'dropdown-select__menu--open': calendarDropdownOpen}\">\n" +
    "                        <li ng-repeat=\"item in clndr.selectableMonths\" ng-class=\"{'selected' : clndr.currentMonth.year == item.year && clndr.currentMonth.month == item.month}\">\n" +
    "                            <a ng-click=\"clndr.showNewMonth(item.month, item.year)\">{{clndr.monthNames[item.month]}} {{item.year}}</a>\n" +
    "                        </li>\n" +
    "                    </ul>\n" +
    "                </div>\n" +
    "                <span\n" +
    "                    class=\"clndr-month\"\n" +
    "                    ng-mouseleave=\"mouseOver.calendarMonth = false\"\n" +
    "                    ng-mouseenter=\"mouseOver.calendarMonth = true; showMonthsDropdown(true);\">\n" +
    "                    <span class=\"link1 link1--smaller link1--emphasis\">\n" +
    "                        {{ clndr.monthNames[clndr.currentMonth.month] }}\n" +
    "                    </span>\n" +
    "                    <span class=\"link1 link1--smaller\">\n" +
    "                        {{ clndr.currentMonth.year }}\n" +
    "                    </span>\n" +
    "                </span>\n" +
    "                <a\n" +
    "                    href=\"\"\n" +
    "                    class=\"link1 link1--smaller clndr-arrow\"\n" +
    "                    ng-click=\"clndr.getPrevMonth()\">\n" +
    "                    &larr;\n" +
    "                </a>\n" +
    "                <a\n" +
    "                    href=\"\"\n" +
    "                    class=\"link1 link1--smaller clndr-arrow\"\n" +
    "                    ng-click=\"clndr.getNextMonth()\">\n" +
    "                    &rarr;\n" +
    "                </a>\n" +
    "                <span class=\"posts-filter__divider link1 link1--smaller\">|</span>\n" +
    "                <a\n" +
    "                    class=\"posts-filter__button link1 link1--smaller link1--muted\"\n" +
    "                    ui-sref=\"home\">\n" +
    "                    Features\n" +
    "                </a>\n" +
    "                <a\n" +
    "                    class=\"posts-filter__button link1 link1--smaller\"\n" +
    "                    ui-sref=\"calendar\">\n" +
    "                    Calendar\n" +
    "                </a>\n" +
    "            </div>\n" +
    "            <div class=\"posts-filter__b\">\n" +
    "                <span class=\"posts-filter__label link1 link1--smaller\">\n" +
    "                    Filter:\n" +
    "                </span>\n" +
    "                <div dropdown-select list=\"eventTypeFilters\" model=\"currentFilters.eventtype\" class=\"posts-filter__dropdown-wrapper posts-filter__dropdown-wrapper--eventtype\"></div>\n" +
    "                <div dropdown-select list=\"programFilters\" multiselect=\"true\" model=\"currentFilters.program\" class=\"posts-filter__dropdown-wrapper posts-filter__dropdown-wrapper--program\"></div>\n" +
    "\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"clndr__grid\">\n" +
    "            <div class=\"clndr__header\">\n" +
    "                <div\n" +
    "                    class=\"clndr__header__day h5\"\n" +
    "                    ng-repeat=\"day in clndr.daysOfTheWeek\">\n" +
    "                    {{ day }}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"clndr__days\">\n" +
    "                <div\n" +
    "                    class=\"clndr__days__day\"\n" +
    "                    ng-click=\"showDay(day.index)\"\n" +
    "                    ng-class=\"[\n" +
    "                        {\n" +
    "                            'clndr__days__day--active' : clndr.selectedDate.index == day.index,\n" +
    "                            'clndr__event' : day.events.length > 0,\n" +
    "                            'clndr__days__day--inactive': clndr.selectedDate && clndr.selectedDate.index != day.index,\n" +
    "                            'first' : $index%7 == 0,\n" +
    "                            'clndr__days__day--current': day.isCurrent\n" +
    "                        },\n" +
    "                        'calendar-dom-'+ {{day.index}}\n" +
    "                        ]\"\n" +
    "                    ng-repeat=\"day in clndr.currentMonth.days\">\n" +
    "                    <span class=\"clndr__days__day__number h5 h5--strong\">\n" +
    "                        {{ day.date }}\n" +
    "                    </span>\n" +
    "                        <div class=\"clndr__days__day__event-container\" ng-show=\"day.events\">\n" +
    "                            <a\n" +
    "                                ng-repeat=\"event in day.events | orderBy:'rank'\"\n" +
    "                                class=\"clndr__days__day__event-container__event\"\n" +
    "                                data-id=\"{{ this.id }}\"\n" +
    "                                ng-style=\"{ 'background-image': 'url(' + event.image + ')' }\"></a>\n" +
    "                        </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"clndr__nav--invisible\">\n" +
    "            <a\n" +
    "                href=\"\"\n" +
    "                class=\"clndr__nav--invisible__btn clndr__nav--invisible__btn-back\"\n" +
    "                ng-click=\"clndr.getPrevMonth()\">\n" +
    "            </a>\n" +
    "            <a\n" +
    "                href=\"\"\n" +
    "                class=\"clndr__nav--invisible__btn clndr__nav--invisible__btn-next\"\n" +
    "                ng-click=\"clndr.getNextMonth()\">\n" +
    "            </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div id=\"clndr__events__holder\"></div>\n" +
    "    <div\n" +
    "        calendar-events\n" +
    "        events=\"clndr.selectedDate.events\"\n" +
    "        date-string=\"{{currentDate.year + '-' + currentDate.month + (currentDate.date ? '-' + currentDate.date : '')}}\"\n" +
    "        ng-class=\"{'showing': clndr.showingEvents}\"\n" +
    "        id=\"clndr__events__section\">\n" +
    "    </div>\n" +
    "    <div class=\"calendar__button-wrap\">\n" +
    "        <a\n" +
    "            class=\"calendar__button\"\n" +
    "            href=\"https://eepurl.com/g1ZRd1\"\n" +
    "            target=\"_blank\">\n" +
    "            Join our weekly event mailer\n" +
    "        </a>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('states/community/community.html',
    "\n" +
    "<div\n" +
    "    class=\"community-page\"\n" +
    "    data-slide-in>\n" +
    "    <div class=\"posts-filter\">\n" +
    "        <div class=\"posts-filter__a\">\n" +
    "            <span class=\"link1 link1--smaller link1--emphasis\">\n" +
    "                Community Activity Feed\n" +
    "            </span>\n" +
    "            <span class=\"link1 link1--smaller\">\n" +
    "                &mdash; Updating Live\n" +
    "            </span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "            dropdown-select\n" +
    "            list=\"programFilters\"\n" +
    "            model=\"currentFilters\"\n" +
    "            multiselect=\"true\"\n" +
    "            class=\"posts-filter__dropdown-wrapper posts-filter__dropdown-wrapper--category\">\n" +
    "        </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"community-page__items\">\n" +
    "        <div\n" +
    "            class=\"post community-page__item\"\n" +
    "            ng-class=\"{ 'post--text': content.type === 'text' }\"\n" +
    "            ng-repeat=\"content in content\">\n" +
    "            <div\n" +
    "                scroll-reveal\n" +
    "                scroll-reveal-delay-random=\"true\">\n" +
    "            <div\n" +
    "                class=\"post__category link1 link1--emphasis\"\n" +
    "                ng-bind=\"content.source\">\n" +
    "            </div>\n" +
    "            <a\n" +
    "                ng-if=\"content.type !== 'text' && content.source != 'youtube'\"\n" +
    "                class=\"post__media-container\"\n" +
    "                ng-href=\"{{ content.post_link }}\"\n" +
    "                target=\"_blank\">\n" +
    "                <img\n" +
    "                    class=\"post__media-container__media\"\n" +
    "                    ng-src=\"{{ content.preview_url }}\"\n" +
    "                    ng-attr-alt=\"{{ content.copy }}\">\n" +
    "            </a>\n" +
    "            <a\n" +
    "                ng-if=\"content.source == 'youtube' && content.type != 'text'\"\n" +
    "                class=\"post__media-container\"\n" +
    "                ng-click=\"openVideo(content.post_link)\">\n" +
    "                <img\n" +
    "                    class=\"post__media-container__media\"\n" +
    "                    ng-src=\"{{ content.preview_url }}\"\n" +
    "                    ng-attr-alt=\"{{ content.copy }}\">\n" +
    "            </a>\n" +
    "            <div class=\"post__info-wrap\">\n" +
    "                <div class=\"post__info\">\n" +
    "                    <div class=\"post__info__excerpt\">\n" +
    "                        <div\n" +
    "                            class=\"post__info__excerpt__body\"\n" +
    "                            data-linkify\n" +
    "                            ng-bind=\"content.copy\"\n" +
    "                            ng-click=\"content.expanded = !content.expanded\"\n" +
    "                            ng-class=\"{'expanded': content.expanded}\">\n" +
    "                        </div>\n" +
    "                        <div class=\"community-page__item__details\">\n" +
    "                            <a\n" +
    "                                ng-href=\"{{ content.user_link }}\"\n" +
    "                                target=\"_blank\"\n" +
    "                                ng-if=\"content.posted_by\">\n" +
    "                                @{{ content.posted_by }}\n" +
    "                            </a><br>\n" +
    "                            {{ content.created_at | date : 'MMM. d' }}\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div id=\"community__modal--video\"\n" +
    "    ng-class=\"{'active': currentVideo}\"\n" +
    "    ng-click=\"closeVideo()\">\n" +
    "    <div class=\"community__modal--video__wrap\" id=\"community__modal--video__wrap\">\n" +
    "        <a class=\"community__modal--video__close\" ng-click=\"closeVideo()\">&#10006;</a>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('states/home/home.html',
    "<div class=\"home\">\n" +
    "    <div\n" +
    "        class=\"home__posts\"\n" +
    "        posts\n" +
    "        posts-data=\"posts\",\n" +
    "        post-filters=\"postFilters\">\n" +
    "    </div>\n" +
    "    <div ui-view id=\"ui-state-holder\" class=\"main-state-area\"></div>\n" +
    "</div>\n"
  );


  $templateCache.put('states/resources/resources.html',
    "<div\n" +
    "    class=\"resources\"\n" +
    "    data-slide-in\n" +
    "    id=\"resources\">\n" +
    "    <div class=\"resources__header-nav\" id=\"resources__header-nav\">\n" +
    "\n" +
    "        <div class=\"resources__header-nav__wrap\" id=\"resources__header-nav__wrap\">\n" +
    "            <div\n" +
    "                class=\"nav\"\n" +
    "                id=\"resources__header-nav__nav\"\n" +
    "                ng-class=\"{'mobile-expanded': mobileTopNavExpanded}\">\n" +
    "                <span\n" +
    "                    class=\"resources__header-nav__nav__link\"\n" +
    "                    ng-repeat=\"section in sections\">\n" +
    "                    <a\n" +
    "                       href=\"\"\n" +
    "                       ng-if=\"!section.contentTypeData['cta-hideTitle'] && section.slug !=='mailing-list'\"\n" +
    "                       class=\"resources__header-nav__section\"\n" +
    "                       ng-class=\"{'active' : sectionMarkers[$index].isActive}\"\n" +
    "                       ng-click=\"scrollToSection(section.slug)\"\n" +
    "                       ng-attr-data-section=\"{{ section.slug }}\">\n" +
    "                       {{section.shortTitle ? section.shortTitle : section.title}}\n" +
    "                    </a>\n" +
    "                </span>\n" +
    "                <span\n" +
    "                    class=\"resources__header-nav__nav__link resources__header-nav__nav__link--buttons\"\n" +
    "                    ng-if=\"buttons\"\n" +
    "                    ng-repeat=\"button in buttons\">\n" +
    "                    <a\n" +
    "                        class=\"resource__header-nav__button\"\n" +
    "                        target=\"_blank\"\n" +
    "                        ng-bind=\"button.text\"\n" +
    "                        ng-href=\"{{ button.url }}\">\n" +
    "                    </a>\n" +
    "                </span>\n" +
    "                <!--<a\n" +
    "                    ng-click=\"toggleMobileTopNav()\"\n" +
    "                    class=\"mobile-only btn-toggle\">{{ mobileTopNavExpanded ? 'Close' : 'Show Menu'}}</a>-->\n" +
    "            </div>\n" +
    "            <div class=\"bar\" scroll-progress-horizontal-bar verticaloffset=\"110\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"resources__header-nav--single\" id=\"resources__header-nav--single\">\n" +
    "        <div class=\"resources__header-nav--single__wrap\" id=\"resources__header-nav--single__wrap\">\n" +
    "            <div class=\"text\" ng-click=\"toggleMobileTopNav()\">{{currentSection.title}}</div>\n" +
    "            <div class=\"bar\" ng-click=\"toggleMobileTopNav()\"><div class=\"text\" id=\"resources__header-nav--single__bar-title\">{{currentSection.title}}</div></div>\n" +
    "\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"nav\"\n" +
    "            id=\"resources__header-nav--single__nav\"\n" +
    "            ng-class=\"{'mobile-expanded': mobileTopNavExpanded}\">\n" +
    "            <span\n" +
    "                ng-repeat=\"section in sections\">\n" +
    "                <a\n" +
    "                   href=\"\"\n" +
    "                   ng-if=\"!section.hideTitle && !section.linkOnly\"\n" +
    "                   class=\"resources__header-nav__section\"\n" +
    "                   ng-class=\"{'active' : sectionMarkers[$index].isActive}\"\n" +
    "                   ng-click=\"scrollToSection(section.slug)\">{{section.shortTitle ? section.shortTitle : section.title}}</a>\n" +
    "                <a\n" +
    "                   href=\"{{section.link}}\"\n" +
    "                   ng-if=\"section.linkOnly && section.linkOut\"\n" +
    "                   target=\"_blank\"\n" +
    "                   class=\"resources__header-nav__section\">{{section.title}}</a>\n" +
    "            </span>\n" +
    "            <!--<a\n" +
    "                ng-click=\"toggleMobileTopNav()\"\n" +
    "                class=\"mobile-only btn-toggle\">{{ mobileTopNavExpanded ? 'Close' : 'Show Menu'}}</a>-->\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"resources__side-nav\" resources-nav position=\"sidenav\">\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "\n" +
    "    <div class=\"resources__main\" id=\"resources__main\">\n" +
    "\n" +
    "        <div\n" +
    "            class=\"resources__main__section\"\n" +
    "            ng-repeat=\"section in sections\"\n" +
    "            ng-if=\"!section.linkOnly\"\n" +
    "            ng-class=\"{'hideTitle': section.hideTitle}\"\n" +
    "            id=\"scrollSection-{{section.slug}}\">\n" +
    "            <div\n" +
    "                resource-text\n" +
    "                ng-if=\"section.type == 'Text'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                content=\"section.contentTypeData\"\n" +
    "                content-title=\"{{ section.contentTypeData['text-hideHeader'] === 'true' ? '' : section.title}}\"></div>\n" +
    "            <div\n" +
    "                resource-panel\n" +
    "                ng-if=\"section.type == 'Panel'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                content=\"section.contentTypeData\"\n" +
    "                content-title=\"{{section.title}}\"></div>\n" +
    "            <div\n" +
    "                resource-textlist\n" +
    "                ng-if=\"section.type == 'text-list'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                content=\"section.contentTypeData\"\n" +
    "                content-title=\"{{section.title}}\"></div>\n" +
    "            <div\n" +
    "                resource-timeline\n" +
    "                ng-if=\"section.type == 'Timeline'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                content=\"section.contentTypeData\"\n" +
    "                content-title=\"{{section.title}}\"></div>\n" +
    "            <div\n" +
    "                resource-grid\n" +
    "                ng-if=\"section.type == 'Grid'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                grid-style=\"{{section.contentTypeData['grid-style']}}\"\n" +
    "                hide-title=\"{{section.hideTitle}}\"\n" +
    "                content=\"section.contentTypeData\"\n" +
    "                content-title=\"{{section.title}}\"></div>\n" +
    "            <div\n" +
    "                resource-cta\n" +
    "                ng-if=\"section.type == 'CTA'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                content=\"section.contentTypeData\"></div>\n" +
    "            <div\n" +
    "                resource-connectform\n" +
    "                ng-if=\"section.type == 'Connect Form'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                content=\"section.contentTypeData\"></div>\n" +
    "            <div\n" +
    "                resource-contactform\n" +
    "                ng-if=\"section.type == 'Contact Form'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                content=\"section.contentTypeData\"\n" +
    "                content-title=\"{{section.title}}\"></div>\n" +
    "            <div\n" +
    "                resource-prospectiveform\n" +
    "                ng-if=\"section.type == 'Prospective Form'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                content=\"section.content\"></div>\n" +
    "            <div\n" +
    "                resource-tourform\n" +
    "                ng-if=\"section.type == 'Tour Form'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                content=\"section.contentTypeData\"></div>\n" +
    "            <div\n" +
    "                resource-jumpable\n" +
    "                ng-if=\"section.type == 'Jumpable Links'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                columns=\"{{ section.contentTypeData['jumpable-links-columns'] }}\"\n" +
    "                content=\"section.contentTypeData['jumpable-links-content']\"\n" +
    "                content-title=\"{{section.title}}\"></div>\n" +
    "            <div\n" +
    "                resource-textphoto\n" +
    "                ng-if=\"section.type == 'Text and Photo'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                content=\"section.contentTypeData\"\n" +
    "                content-title=\"{{section.title}}\"></div>\n" +
    "            <div\n" +
    "                resource-map\n" +
    "                ng-if=\"section.type == 'Map'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                content=\"section.contentTypeData\"\n" +
    "                content-title=\"{{section.title}}\"></div>\n" +
    "            <div\n" +
    "                data-resource-slideshow\n" +
    "                ng-if=\"section.type == 'Slideshow'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                content=\"section.contentTypeData['slideshow-content']\"\n" +
    "                content-title=\"{{ section.title }}\"></div>\n" +
    "            <div\n" +
    "                data-resource-post-slideshow\n" +
    "                ng-if=\"section.type == 'Post Slideshow'\"\n" +
    "                section-index=\"{{ $index }}\"\n" +
    "                slugs=\"section.contentTypeData['post-slideshow-content']\"\n" +
    "                content-title=\"{{ section.title }}\"></div>\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "\n" +
    "</div>\n"
  );


  $templateCache.put('states/single/info.html',
    "<div class=\"single\">\n" +
    "\n" +
    "    <div class=\"single__title-block\">\n" +
    "        <h2 class=\"single__title-block__title single__title-block__title--condensed\">UCLA Arts Tour Reservation Confirmation </h2>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"single__no-print\" style=\"text-align: center;\"><a style=\"background-color: #084283; font-family: Arial; font-size: 16px; padding: 20px; color: #ffffff; center;text-decoration: none;\" ng-click=\"print();\" href=\"#\">PRINT CONFIRMATION</a></div><br>\n" +
    "\n" +
    "    <div class=\"single__content\">\n" +
    "\n" +
    "        <p><strong>{{tour}}</strong></p>\n" +
    "        <p><strong>Number of Attendees:</strong> {{guests}}</p>\n" +
    "\n" +
    "        <p>We’re looking forward to welcoming you to the UCLA campus for the UCLA Arts tour.  The tour begins in front of the Broad Art Center in the plaza, and we meet at the Richard Serra sculpture.  </p>\n" +
    "\n" +
    "        <p>Here are driving directions to campus: </p>\n" +
    "\n" +
    "        <p>From the 405 Freeway, exit Sunset Blvd, headed due east.\n" +
    "        Follow Sunset a little ways-- you'll pass the Bel Air gates, and UCLA campus will show up on your right; keep going.</p>\n" +
    "\n" +
    "        <p>Pass the light at Stone Canyon, and the next light after that is Hilgard.  Make a right turn onto Hilgard.\n" +
    "        Make an almost immediate right turn into the driveway after the bus stop.  You will see Parking Lot 3, and follow the instructions to park in the green “Pay By Space” spots.</p>\n" +
    "\n" +
    "        <p>This street you are now on, the campus road parallel to Hilgard, is Charles Young Drive West.  Walk south on CYD; you will see a stop sign and intersection.</p>\n" +
    "\n" +
    "        <p>Make a right at this stop sign.  You are now on Charles Young Drive North.\n" +
    "        Walk a ways to the next stop sign.  Here to your left there is a long driveway and patio to a big white building; this is the Broad Art Center.</p>\n" +
    "        <p>Follow the driveway to the doors, go through the building, and take the stairway to your right down to the ground.  The Serra torque ellipse sculpture will be directly in front of you.</p>\n" +
    "\n" +
    "        <p>Here are directions to and parking information for the Broad Art Center: <a href=\"http://arts.ucla.edu/resource/about/map/\" target=\"_blank\">http://arts.ucla.edu/resource/about/map/</a></p>\n" +
    "\n" +
    "        <p>Direct Google Maps link to Broad Art Center: <a href=\"http://g.co/maps/jg5a7\" target=\"_blank\">http://g.co/maps/jg5a7</a></p>\n" +
    "\n" +
    "        <p>If you require assistance or need to cancel your tour, please call our office: 310.825.8981. </p>\n" +
    "\n" +
    "        <p>Thank you very much and we look forward to greeting you! </p>\n" +
    "\n" +
    "        <p>Best regards, </p>\n" +
    "\n" +
    "        <p>Laura Young <br>\n" +
    "        Director, Enrollment Management<br>\n" +
    "        UCLA School of the Arts and Architecture</p>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div\n" +
    "        ng-if=\"content.category.toLowerCase()=='event'\"\n" +
    "        class=\"single__bottom__link\">\n" +
    "            <a\n" +
    "                class=\"link1 link1--smaller\"\n" +
    "                target=\"_blank\"\n" +
    "                ng-href=\"https://calendar.google.com/calendar/render?action=TEMPLATE&text={{ content.title }}&dates={{ displayDate.google.start }}/{{ displayDate.google.end }}&details={{ content.subtitle ? (content.subtitle + '%0A%0A') : '' | htmlToPlaintext | spacesToPlus }}{{ content.summary | htmlToPlaintext | spacesToPlus }}&sf=true&output=xml\">add to google Calendar</a>\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n"
  );


  $templateCache.put('states/single/single.html',
    "<div class=\"single\">\n" +
    "\n" +
    "\n" +
    "        <div class=\"posts-filter\">\n" +
    "            <div class=\"posts-filter__a\">\n" +
    "                <span class=\"link1 link1--smaller\">\n" +
    "                    Posted on\n" +
    "                </span>\n" +
    "                <span class=\"link1 link1--smaller link1--emphasis\">\n" +
    "                    {{ content.post_date | date : 'MMMM d, yyyy'}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "            <div class=\"posts-filter__c\">\n" +
    "\n" +
    "                <span class=\"link1 link1--smaller\">\n" +
    "                    <a ui-sref=\"{{referrer + (referrerDate ? '({ date :\\'' + referrerDate + '\\'})' : '')}}\">Back to {{ referrerTitle }}</a>\n" +
    "                </span>\n" +
    "\n" +
    "            </div>\n" +
    "            <div class=\"posts-filter__b\">\n" +
    "                <span class=\"posts-filter__label link1 link1--smaller posts-filter__share-label\">\n" +
    "                    Share:\n" +
    "                </span>\n" +
    "                <div class=\"single__share-icons\">\n" +
    "                    <a class=\"share__icon single__share__icon\" ng-click=\"windowpop('https://plus.google.com/share?url=' + encodeURIComponent(window.location.href), 500, 600);\" target=\"_blank\">\n" +
    "                        <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "                             viewBox=\"0 0 312 312\" enable-background=\"new 0 0 312 312\" xml:space=\"preserve\">\n" +
    "                        <rect x=\"0\" y=\"0\" fill=\"#FFFFFF\" width=\"312\" height=\"312\" fill-opacity=\"0\"/>\n" +
    "                        <g>\n" +
    "                            <path d=\"M186.8,139.1c-0.6-0.1-1-0.1-1.4-0.1c-25.5,0-50.9,0-76.4,0c-1.2,0-1.5,0.4-1.5,1.5c0.1,10.3,0.1,20.5,0.1,30.8\n" +
    "                                c0,1.6,0,1.6,1.7,1.6c13.9,0,27.8,0,41.7,0c0.5,0,1,0,1.6,0c0,0.3,0.1,0.3,0.1,0.4c-2.2,10.5-7.7,18.9-16.7,25\n" +
    "                                c-6.8,4.6-14.4,6.9-22.6,7.6c-5.8,0.5-11.5,0.3-17.1-1.1c-25.9-6.7-42.4-33-36.5-59.8c5.3-23.8,27.5-41.6,53.2-38.9\n" +
    "                                c9.5,1,17.9,4.5,25.1,10.7c0.6,0.5,1.1,1,1.6,1.3c8.2-8.2,16.2-16.3,24.4-24.5c-0.2-0.1-0.4-0.3-0.7-0.5\n" +
    "                                c-14.4-13.1-31.4-20.1-50.8-21.2c-7.2-0.4-14.4,0.1-21.5,1.5c-16.2,3.4-30.3,10.7-42,22.3c-15.4,15.1-23.8,33.7-25.3,55.3\n" +
    "                                c-0.5,7.6,0.1,15.3,1.8,22.8c4.4,19.3,14.2,35.3,29.6,47.7c14,11.3,30.2,17.4,48.2,18.4c9.3,0.5,18.5-0.3,27.5-2.7\n" +
    "                                c22.9-6.1,39.6-19.8,49.7-41.3c4.9-10.6,7.3-21.9,7.7-33.6c0.2-4.9-0.1-9.9-0.4-14.8C187.8,144.7,187.2,141.9,186.8,139.1z\" fill=\"#b6c3d7\" class=\"path\" />\n" +
    "                            <path d=\"M258.9,164c0-0.5,0-1.1,0-1.7c9.9,0,19.6,0,29.4,0c0-0.7,0-1.1,0-1.6c0-5.9,0-11.8,0-17.8c0-1.7,0-1.7-1.7-1.7\n" +
    "                                c-8.6,0-17.3,0-26,0c-0.6,0-1.1-0.1-1.8-0.1c0-9.8,0-19.5,0-29.2c-0.6,0-1,0-1.4,0c-6,0-12.1,0.1-18.1,0c-1.3,0-1.6,0.5-1.6,1.7\n" +
    "                                c0.1,8.7,0.1,17.3,0.1,26c0,1.8,0,1.8-1.8,1.8c-8.6,0-17.2,0-25.8,0c-0.5,0-1.1,0.1-1.6,0.1c0,7.1,0,14,0,21.1c9.8,0,19.5,0,29.3,0\n" +
    "                                c0,0.6,0,1,0,1.5c0,8.8,0,17.6-0.1,26.5c0,1.1,0.3,1.5,1.5,1.5c6.1-0.1,12.2-0.1,18.3,0c1.1,0,1.4-0.3,1.4-1.4\n" +
    "                                C258.8,181.6,258.9,172.8,258.9,164z\" fill=\"#b6c3d7\" class=\"path\" />\n" +
    "                        </g>\n" +
    "                        </svg>\n" +
    "\n" +
    "                    </a>\n" +
    "\n" +
    "                    <a class=\"share__icon single__share__icon\" ng-click=\"windowpop('https://twitter.com/share?url='+encodeURIComponent(window.location.href) + '&amp;text=' +  encodeURIComponent(document.title), 600, 280);\" target=\"_blank\">\n" +
    "                        <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "                             viewBox=\"0 0 312 312\" enable-background=\"new 0 0 312 312\" xml:space=\"preserve\">\n" +
    "                        <rect x=\"0\" y=\"0\" fill=\"#FFFFFF\" width=\"312\" height=\"312\" fill-opacity=\"0\"/>\n" +
    "                        <path d=\"M272.8,104.5c-6.8,3-14.2,5.1-21.9,6c7.9-4.7,13.9-12.2,16.7-21.1c-7.4,4.4-15.5,7.5-24.2,9.2c-6.9-7.4-16.8-12-27.8-12\n" +
    "                            c-21,0-38.1,17-38.1,38.1c0,3,0.3,5.9,1,8.7c-31.6-1.6-59.7-16.7-78.5-39.8c-3.3,5.6-5.2,12.2-5.2,19.1c0,13.2,6.7,24.9,16.9,31.7\n" +
    "                            c-6.2-0.2-12.1-1.9-17.2-4.8c0,0.2,0,0.3,0,0.5c0,18.4,13.1,33.8,30.5,37.3c-3.2,0.9-6.6,1.3-10,1.3c-2.5,0-4.8-0.2-7.2-0.7\n" +
    "                            c4.8,15.1,18.9,26.1,35.6,26.4c-13,10.2-29.4,16.3-47.3,16.3c-3.1,0-6.1-0.2-9.1-0.5c16.8,10.8,36.9,17.1,58.4,17.1\n" +
    "                            c70,0,108.3-58,108.3-108.3c0-1.7,0-3.3-0.1-4.9C261.2,118.8,267.7,112.1,272.8,104.5z\" class=\"path\" fill=\"#b6c3d7\" />\n" +
    "                        </svg>\n" +
    "                    </a>\n" +
    "\n" +
    "                    <a class=\"share__icon single__share__icon\" ng-click=\"windowpop('https://www.facebook.com/sharer.php?u=' + encodeURIComponent(window.location.href), 600, 600);\" target=\"_blank\">\n" +
    "                        <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "                             viewBox=\"-26.4 -26.7 312 312\" enable-background=\"new -26.4 -26.7 312 312\" xml:space=\"preserve\">\n" +
    "                        <rect x=\"-26.4\" y=\"-26.7\" fill=\"#FFFFFF\" width=\"312\" height=\"312\" fill-opacity=\"0\"/>\n" +
    "                        <path d=\"M104.3,74.9v16.5H86.9v29.1h17.4v81.2h34.3v-81.2h22.6l3-29.1h-25.6V74.9c0-4.8,2.2-8.3,8.3-8.3h17.4V38.9h-25.6\n" +
    "                            C110.8,39.7,104.3,55.4,104.3,74.9z\" fill=\"#b6c3d7\" class=\"path\" />\n" +
    "                        </svg>\n" +
    "\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "    <div class=\"single__featured-img\">\n" +
    "        <!-- <div class=\"single__program link1\" ng-if=\"content.programs[0]\">{{ content.programs[0].name }}</div> -->\n" +
    "        <div\n" +
    "            class=\"single__featured-img__background\"\n" +
    "            ng-style=\"{'background-image':'url({{ content.image }})'}\"></div>\n" +
    "        <img\n" +
    "            class=\"single__featured-img__image\"\n" +
    "            ng-src=\"{{ content.image }}\">\n" +
    "\n" +
    "        <div\n" +
    "            ng-if=\"content.category.toLowerCase()=='event'\"\n" +
    "            class=\"single__event-date\">\n" +
    "            {{ displayDate.dayWeekStart }}, <strong>{{ displayDate.dateStart }}{{ displayDate.dateEnd ? \" - \" + displayDate.dateEnd : \"\"}}</strong> {{ displayDate.timeStart ? \" @ \" + displayDate.timeStart : \"\"}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"single__title-block\">\n" +
    "        <h2 class=\"single__title-block__title\">{{ content.title }}</h2>\n" +
    "        <h3 class=\"single__title-block__subtitle\" ng-if=\"content.subtitle\">{{ content.subtitle }}</h3>\n" +
    "        <div class=\"single__title-block__programstags\" ng-if=\"content.programs.length > 0 || content.tags.length > 0\">\n" +
    "            <div class=\"single__title-block__programs\" ng-if=\"content.programs.length > 0\">\n" +
    "                <a ui-sref=\"home({program: program.slug})\" ng-repeat=\"program in content.programs\">{{ $index > 0 ? \", \" : \"\"}}{{program.name}}</a>\n" +
    "            </div>\n" +
    "            <div class=\"single__title-block__tags\" ng-if=\"content.tags.length > 0\">\n" +
    "            <a ui-sref=\"home({tag: tag.slug})\" ng-repeat=\"tag in content.tags\">{{ $index > 0 ? \", \" : \"\"}}{{tag.name}}</a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"single__social-share\">\n" +
    "\n" +
    "        <div class=\"single__share-icons\">\n" +
    "            <a class=\"share__icon single__share__icon\" ng-click=\"windowpop('https://plus.google.com/share?url=' + encodeURIComponent(window.location.href), 500, 600);\" target=\"_blank\">\n" +
    "                <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "                     viewBox=\"0 0 312 312\" enable-background=\"new 0 0 312 312\" xml:space=\"preserve\">\n" +
    "                <rect x=\"0\" y=\"0\" fill=\"#FFFFFF\" width=\"312\" height=\"312\" fill-opacity=\"0\"/>\n" +
    "                <g>\n" +
    "                    <path d=\"M186.8,139.1c-0.6-0.1-1-0.1-1.4-0.1c-25.5,0-50.9,0-76.4,0c-1.2,0-1.5,0.4-1.5,1.5c0.1,10.3,0.1,20.5,0.1,30.8\n" +
    "                        c0,1.6,0,1.6,1.7,1.6c13.9,0,27.8,0,41.7,0c0.5,0,1,0,1.6,0c0,0.3,0.1,0.3,0.1,0.4c-2.2,10.5-7.7,18.9-16.7,25\n" +
    "                        c-6.8,4.6-14.4,6.9-22.6,7.6c-5.8,0.5-11.5,0.3-17.1-1.1c-25.9-6.7-42.4-33-36.5-59.8c5.3-23.8,27.5-41.6,53.2-38.9\n" +
    "                        c9.5,1,17.9,4.5,25.1,10.7c0.6,0.5,1.1,1,1.6,1.3c8.2-8.2,16.2-16.3,24.4-24.5c-0.2-0.1-0.4-0.3-0.7-0.5\n" +
    "                        c-14.4-13.1-31.4-20.1-50.8-21.2c-7.2-0.4-14.4,0.1-21.5,1.5c-16.2,3.4-30.3,10.7-42,22.3c-15.4,15.1-23.8,33.7-25.3,55.3\n" +
    "                        c-0.5,7.6,0.1,15.3,1.8,22.8c4.4,19.3,14.2,35.3,29.6,47.7c14,11.3,30.2,17.4,48.2,18.4c9.3,0.5,18.5-0.3,27.5-2.7\n" +
    "                        c22.9-6.1,39.6-19.8,49.7-41.3c4.9-10.6,7.3-21.9,7.7-33.6c0.2-4.9-0.1-9.9-0.4-14.8C187.8,144.7,187.2,141.9,186.8,139.1z\" fill=\"#b6c3d7\" class=\"path\" />\n" +
    "                    <path d=\"M258.9,164c0-0.5,0-1.1,0-1.7c9.9,0,19.6,0,29.4,0c0-0.7,0-1.1,0-1.6c0-5.9,0-11.8,0-17.8c0-1.7,0-1.7-1.7-1.7\n" +
    "                        c-8.6,0-17.3,0-26,0c-0.6,0-1.1-0.1-1.8-0.1c0-9.8,0-19.5,0-29.2c-0.6,0-1,0-1.4,0c-6,0-12.1,0.1-18.1,0c-1.3,0-1.6,0.5-1.6,1.7\n" +
    "                        c0.1,8.7,0.1,17.3,0.1,26c0,1.8,0,1.8-1.8,1.8c-8.6,0-17.2,0-25.8,0c-0.5,0-1.1,0.1-1.6,0.1c0,7.1,0,14,0,21.1c9.8,0,19.5,0,29.3,0\n" +
    "                        c0,0.6,0,1,0,1.5c0,8.8,0,17.6-0.1,26.5c0,1.1,0.3,1.5,1.5,1.5c6.1-0.1,12.2-0.1,18.3,0c1.1,0,1.4-0.3,1.4-1.4\n" +
    "                        C258.8,181.6,258.9,172.8,258.9,164z\" fill=\"#b6c3d7\" class=\"path\" />\n" +
    "                </g>\n" +
    "                </svg>\n" +
    "\n" +
    "            </a>\n" +
    "\n" +
    "            <a class=\"share__icon single__share__icon\" ng-click=\"windowpop('https://twitter.com/share?url='+encodeURIComponent(window.location.href) + '&amp;text=' +  encodeURIComponent(document.title), 600, 280);\" target=\"_blank\">\n" +
    "                <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "                     viewBox=\"0 0 312 312\" enable-background=\"new 0 0 312 312\" xml:space=\"preserve\">\n" +
    "                <rect x=\"0\" y=\"0\" fill=\"#FFFFFF\" width=\"312\" height=\"312\" fill-opacity=\"0\"/>\n" +
    "                <path d=\"M272.8,104.5c-6.8,3-14.2,5.1-21.9,6c7.9-4.7,13.9-12.2,16.7-21.1c-7.4,4.4-15.5,7.5-24.2,9.2c-6.9-7.4-16.8-12-27.8-12\n" +
    "                    c-21,0-38.1,17-38.1,38.1c0,3,0.3,5.9,1,8.7c-31.6-1.6-59.7-16.7-78.5-39.8c-3.3,5.6-5.2,12.2-5.2,19.1c0,13.2,6.7,24.9,16.9,31.7\n" +
    "                    c-6.2-0.2-12.1-1.9-17.2-4.8c0,0.2,0,0.3,0,0.5c0,18.4,13.1,33.8,30.5,37.3c-3.2,0.9-6.6,1.3-10,1.3c-2.5,0-4.8-0.2-7.2-0.7\n" +
    "                    c4.8,15.1,18.9,26.1,35.6,26.4c-13,10.2-29.4,16.3-47.3,16.3c-3.1,0-6.1-0.2-9.1-0.5c16.8,10.8,36.9,17.1,58.4,17.1\n" +
    "                    c70,0,108.3-58,108.3-108.3c0-1.7,0-3.3-0.1-4.9C261.2,118.8,267.7,112.1,272.8,104.5z\" class=\"path\" fill=\"#b6c3d7\" />\n" +
    "                </svg>\n" +
    "            </a>\n" +
    "\n" +
    "            <a class=\"share__icon single__share__icon\" ng-click=\"windowpop('https://www.facebook.com/sharer.php?u=' + encodeURIComponent(window.location.href), 600, 600);\" target=\"_blank\">\n" +
    "                <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
    "                     viewBox=\"-26.4 -26.7 312 312\" enable-background=\"new -26.4 -26.7 312 312\" xml:space=\"preserve\">\n" +
    "                <rect x=\"-26.4\" y=\"-26.7\" fill=\"#FFFFFF\" width=\"312\" height=\"312\" fill-opacity=\"0\"/>\n" +
    "                <path d=\"M104.3,74.9v16.5H86.9v29.1h17.4v81.2h34.3v-81.2h22.6l3-29.1h-25.6V74.9c0-4.8,2.2-8.3,8.3-8.3h17.4V38.9h-25.6\n" +
    "                    C110.8,39.7,104.3,55.4,104.3,74.9z\" fill=\"#b6c3d7\" class=\"path\" />\n" +
    "                </svg>\n" +
    "\n" +
    "            </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div\n" +
    "        class=\"single__content\"\n" +
    "        ng-bind-html=\"content.body | toTrusted\">\n" +
    "    </div>\n" +
    "    <div class=\"single__content\"\n" +
    "\n" +
    "        <div\n" +
    "            resource-slideshow\n" +
    "            ng-if=\"content.slideshow\"\n" +
    "            content=\"content.slideshow\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div\n" +
    "        ng-if=\"content.category.toLowerCase()=='event'\"\n" +
    "        class=\"single__bottom__link\">\n" +
    "            <a\n" +
    "                class=\"link1 link1--smaller\"\n" +
    "                target=\"_blank\"\n" +
    "                ng-href=\"https://calendar.google.com/calendar/render?action=TEMPLATE&text={{ content.title }}&dates={{ displayDate.google.start }}/{{ displayDate.google.end }}&details={{ content.subtitle ? (content.subtitle + '%0A%0A') : '' | htmlToPlaintext | spacesToPlus }}{{ content.summary | htmlToPlaintext | spacesToPlus }}&sf=true&output=xml\">add to google Calendar</a>\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n"
  );

}]);
